/**
 * Generated registry types — DO NOT EDIT MANUALLY
 *
 * Run: node scripts/codegen/generate-registry-constants.mjs
 *
 * DRR-218: Unified Registry & Codegen System
 */

// ══════════════════════════════════════════════════════════════════════════════
// SCOPES
// ══════════════════════════════════════════════════════════════════════════════

export enum Scope {
  /** Create customer records */
  AccountingCustomerCreate = 'accounting:customer:create',
  /** Read customer records */
  AccountingCustomerRead = 'accounting:customer:read',
  /** Create GL accounts */
  AccountingGlCreate = 'accounting:gl:create',
  /** Read general ledger */
  AccountingGlRead = 'accounting:gl:read',
  /** Create invoices */
  AccountingInvoiceCreate = 'accounting:invoice:create',
  /** Read invoices */
  AccountingInvoiceRead = 'accounting:invoice:read',
  /** Create journal entries */
  AccountingJournalCreate = 'accounting:journal:create',
  /** Read journal entries */
  AccountingJournalRead = 'accounting:journal:read',
  /** Update journal entries */
  AccountingJournalUpdate = 'accounting:journal:update',
  /** Read all accounting data */
  AccountingRead = 'accounting:read',
  /** Create vendor records */
  AccountingVendorCreate = 'accounting:vendor:create',
  /** Read vendor records */
  AccountingVendorRead = 'accounting:vendor:read',
  /** Update vendor records */
  AccountingVendorUpdate = 'accounting:vendor:update',
  /** Write all accounting data */
  AccountingWrite = 'accounting:write',
  /** Administer actor entities */
  ActorAdmin = 'actor:admin',
  /** Read actor entities */
  ActorRead = 'actor:read',
  /** Create/update actor entities */
  ActorWrite = 'actor:write',
  /** Basic admin layer access for navigation groups (DRR-283) */
  AdminAccess = 'admin:access',
  /** Manage admissions */
  AdmissionManage = 'admission:manage',
  /** Generate advocacy reports (architect only) */
  AdvocacyGenerate = 'advocacy:generate',
  /** Submit advocacy data */
  AdvocacySubmit = 'advocacy:submit',
  /** View advocacy data */
  AdvocacyView = 'advocacy:view',
  /** Read analytics data */
  AnalyticsRead = 'analytics:read',
  /** View analytics dashboards */
  AnalyticsView = 'analytics:view',
  /** Write analytics data */
  AnalyticsWrite = 'analytics:write',
  /** Administer annotations */
  AnnotationAdmin = 'annotation:admin',
  /** Read annotations */
  AnnotationRead = 'annotation:read',
  /** Write annotations */
  AnnotationWrite = 'annotation:write',
  /** Administer approvals */
  ApprovalAdmin = 'approval:admin',
  /** Create approval requests */
  ApprovalCreate = 'approval:create',
  /** Read approvals */
  ApprovalRead = 'approval:read',
  /** Create/update approvals */
  ApprovalWrite = 'approval:write',
  /** Dismiss assessments */
  AssessmentDismiss = 'assessment:dismiss',
  /** Manage assessments */
  AssessmentManage = 'assessment:manage',
  /** Read assessments */
  AssessmentRead = 'assessment:read',
  /** Generate assessment reports */
  AssessmentReport = 'assessment:report',
  /** Store signed assessments (DRR-329: clinical documentation) */
  AssessmentStore = 'assessment:store',
  /** Query AI assistant */
  AssistantQuery = 'assistant:query',
  /** Read audit logs */
  AuditRead = 'audit:read',
  /** MFA operations */
  AuthMfa = 'auth:mfa',
  /** Read auth configuration */
  AuthRead = 'auth:read',
  /** Read billing/insurance data (field-level visibility) */
  BillingRead = 'billing:read',
  /** Write billing/insurance data */
  BillingWrite = 'billing:write',
  /** Approve care plans (ALD, DoN, CEO) */
  CarePlanApprove = 'care_plan:approve',
  /** Create care plans (RN, QP) */
  CarePlanCreate = 'care_plan:create',
  /** Read care plans */
  CarePlanRead = 'care_plan:read',
  /** CFSS agency provider — coordinate services */
  CfssAgency = 'cfss:agency',
  /** CFSS participant — view own services, select workers */
  CfssParticipant = 'cfss:participant',
  /** CFSS qualified professional — clinical oversight */
  CfssQp = 'cfss:qp',
  /** CFSS support worker — relationship-filtered access */
  CfssWorker = 'cfss:worker',
  /** Administer checkpoints */
  CheckpointAdmin = 'checkpoint:admin',
  /** Read checkpoints */
  CheckpointRead = 'checkpoint:read',
  /** Create/update checkpoints */
  CheckpointWrite = 'checkpoint:write',
  /** Full clinical access */
  ClinicalFull = 'clinical:full',
  /** Read clinical data */
  ClinicalRead = 'clinical:read',
  /** Standard clinical operations */
  ClinicalStandard = 'clinical:standard',
  /** Write clinical data (FHIR status updates, care plan modifications) */
  ClinicalWrite = 'clinical:write',
  /** Manage compliance workflows */
  ComplianceManage = 'compliance:manage',
  /** Read compliance data */
  ComplianceRead = 'compliance:read',
  /** Write compliance data */
  ComplianceWrite = 'compliance:write',
  /** Read compositions */
  CompositionRead = 'composition:read',
  /** Write compositions */
  CompositionWrite = 'composition:write',
  /** Read configuration */
  ConfigRead = 'config:read',
  /** Administer constraints */
  ConstraintAdmin = 'constraint:admin',
  /** Read constraints */
  ConstraintRead = 'constraint:read',
  /** Create/update constraints */
  ConstraintWrite = 'constraint:write',
  /** Administer contracts */
  ContractAdmin = 'contract:admin',
  /** Read contracts */
  ContractRead = 'contract:read',
  /** Create/update contracts */
  ContractWrite = 'contract:write',
  /** Read coordination data */
  CoordinationRead = 'coordination:read',
  /** Manage clinical delegation (144G.71) — assign ULP to tasks, verify competency */
  DelegationManage = 'delegation:manage',
  /** View delivery assignments and route info */
  DeliveryView = 'delivery:view',
  /** Administer dependencies */
  DependencyAdmin = 'dependency:admin',
  /** Read dependencies */
  DependencyRead = 'dependency:read',
  /** Create/update dependencies */
  DependencyWrite = 'dependency:write',
  /** Administer documents */
  DocumentAdmin = 'document:admin',
  /** Encrypt documents */
  DocumentEncrypt = 'document:encrypt',
  /** Generate documents (PDF, etc.) */
  DocumentGenerate = 'document:generate',
  /** Read documents */
  DocumentRead = 'document:read',
  /** Sign documents */
  DocumentSign = 'document:sign',
  /** Create/update documents */
  DocumentWrite = 'document:write',
  /** Director of Nursing full access */
  DonAll = 'don:all',
  /** Read EDI claims */
  EdiClaimRead = 'edi:claim:read',
  /** Read all EDI data */
  EdiRead = 'edi:read',
  /** Read EDI transactions */
  EdiTransactionRead = 'edi:transaction:read',
  /** Write all EDI data */
  EdiWrite = 'edi:write',
  /** View active emergency blocks on actors/roles */
  EmergencyBlockRead = 'emergency:block:read',
  /** Create/extend/remove emergency blocks (subtractive access revocation) */
  EmergencyBlockWrite = 'emergency:block:write',
  /** Create enrollments */
  EnrollmentCreate = 'enrollment:create',
  /** Read all ERP data */
  ErpRead = 'erp:read',
  /** Write all ERP data */
  ErpWrite = 'erp:write',
  /** Read events */
  EventRead = 'event:read',
  /** Create/update events */
  EventWrite = 'event:write',
  /** Administer exchange */
  ExchangeAdmin = 'exchange:admin',
  /** Push to exchange */
  ExchangePush = 'exchange:push',
  /** Read exchange data */
  ExchangeRead = 'exchange:read',
  /** Revoke exchange access */
  ExchangeRevoke = 'exchange:revoke',
  /** Facility-level administration (ALD oversight of all subjects) */
  FacilityAdmin = 'facility:admin',
  /** Read federation data */
  FederationRead = 'federation:read',
  /** Create FHIR AllergyIntolerance resources */
  FhirAllergyintoleranceCreate = 'fhir:allergyintolerance:create',
  /** Read FHIR AllergyIntolerance resources */
  FhirAllergyintoleranceRead = 'fhir:allergyintolerance:read',
  /** Create FHIR CarePlan resources */
  FhirCareplanCreate = 'fhir:careplan:create',
  /** Read FHIR CarePlan resources */
  FhirCareplanRead = 'fhir:careplan:read',
  /** Update FHIR CarePlan resources */
  FhirCareplanUpdate = 'fhir:careplan:update',
  /** Create FHIR CareTeam resources */
  FhirCareteamCreate = 'fhir:careteam:create',
  /** Read FHIR CareTeam resources */
  FhirCareteamRead = 'fhir:careteam:read',
  /** Create FHIR Claim resources */
  FhirClaimCreate = 'fhir:claim:create',
  /** Read FHIR Claim resources */
  FhirClaimRead = 'fhir:claim:read',
  /** Update FHIR Claim resources */
  FhirClaimUpdate = 'fhir:claim:update',
  /** Read FHIR ClaimResponse resources (adjudication) */
  FhirClaimresponseRead = 'fhir:claimresponse:read',
  /** Create FHIR Condition resources */
  FhirConditionCreate = 'fhir:condition:create',
  /** Read FHIR Condition resources (diagnoses) */
  FhirConditionRead = 'fhir:condition:read',
  /** Read FHIR DiagnosticReport resources */
  FhirDiagnosticRead = 'fhir:diagnostic:read',
  /** Create FHIR Encounter resources */
  FhirEncounterCreate = 'fhir:encounter:create',
  /** Read FHIR Encounter resources */
  FhirEncounterRead = 'fhir:encounter:read',
  /** Prescribe medications (licensed staff) */
  FhirMedicationPrescribe = 'fhir:medication:prescribe',
  /** Read FHIR Medication resources */
  FhirMedicationRead = 'fhir:medication:read',
  /** Create FHIR MedicationAdministration records */
  FhirMedicationadministrationCreate = 'fhir:medicationadministration:create',
  /** Read FHIR MedicationAdministration resources */
  FhirMedicationadministrationRead = 'fhir:medicationadministration:read',
  /** Create FHIR MedicationRequest resources */
  FhirMedicationrequestCreate = 'fhir:medicationrequest:create',
  /** Read FHIR MedicationRequest resources (orders) */
  FhirMedicationrequestRead = 'fhir:medicationrequest:read',
  /** Read FHIR MedicationStatement resources */
  FhirMedicationstatementRead = 'fhir:medicationstatement:read',
  /** Create FHIR Observation resources */
  FhirObservationCreate = 'fhir:observation:create',
  /** Read FHIR Observation resources (vitals, ADLs) */
  FhirObservationRead = 'fhir:observation:read',
  /** Create FHIR Patient resources */
  FhirPatientCreate = 'fhir:patient:create',
  /** Read FHIR Patient resources */
  FhirPatientRead = 'fhir:patient:read',
  /** Update FHIR Patient resources */
  FhirPatientUpdate = 'fhir:patient:update',
  /** Read FHIR Practitioner resources */
  FhirPractitionerRead = 'fhir:practitioner:read',
  /** Read FHIR PractitionerRole resources */
  FhirPractitionerroleRead = 'fhir:practitionerrole:read',
  /** Create FHIR Procedure resources */
  FhirProcedureCreate = 'fhir:procedure:create',
  /** Read FHIR Procedure resources */
  FhirProcedureRead = 'fhir:procedure:read',
  /** Read all FHIR resources */
  FhirRead = 'fhir:read',
  /** Write all FHIR resources */
  FhirWrite = 'fhir:write',
  /** Line cook station access - view and update orders */
  FoodServiceCook = 'food-service:cook',
  /** Driver access - view deliveries, mark delivered */
  FoodServiceDriver = 'food-service:driver',
  /** Expeditor access - QC, dispatch, driver assignment */
  FoodServiceExpo = 'food-service:expo',
  /** Kitchen manager - full operations access */
  FoodServiceManager = 'food-service:manager',
  /** Read form schemas */
  FormsRead = 'forms:read',
  /** Write form schemas */
  FormsWrite = 'forms:write',
  /** Propose form schema changes (requires admin approval) */
  FormschemaPropose = 'formschema:propose',
  /** Read form schema definitions */
  FormschemaRead = 'formschema:read',
  /** Create/update form schemas (system architect) */
  FormschemaWrite = 'formschema:write',
  /** Read graph data */
  GraphRead = 'graph:read',
  /** Investigate incidents (ALD, DoN, CEO) */
  IncidentInvestigate = 'incident:investigate',
  /** Read incident reports */
  IncidentRead = 'incident:read',
  /** Create incident reports */
  IncidentReport = 'incident:report',
  /** Administer workflow instances */
  InstanceAdmin = 'instance:admin',
  /** Read workflow instances */
  InstanceRead = 'instance:read',
  /** Create/update workflow instances */
  InstanceWrite = 'instance:write',
  /** Invoke external integrations (DRR-329) */
  IntegrationInvoke = 'integration:invoke',
  /** Read integration configurations */
  IntegrationRead = 'integration:read',
  /** Create/update integrations */
  IntegrationWrite = 'integration:write',
  /** Kitchen operations management - staffing, inventory, compliance */
  KitchenManage = 'kitchen:manage',
  /** Read ledger entries */
  LedgerRead = 'ledger:read',
  /** Write ledger entries */
  LedgerWrite = 'ledger:write',
  /** Create and fire lifecycle instances (subject lifecycle transitions) */
  LifecycleManage = 'lifecycle:manage',
  /** Access MCP tools and resources (ingest events, generate summaries) */
  McpAccess = 'mcp:access',
  /** Administer MCP settings (toggle embedded/standalone, thresholds) */
  McpAdmin = 'mcp:admin',
  /** Full medication administration (licensed staff only — RN/LPN) */
  MedicationAdmin = 'medication:admin',
  /** Delegated medication administration (ULP under 144G.71) */
  MedicationAdminDelegated = 'medication:admin_delegated',
  /** Administer medications to residents (delegated ULP, Med Aide, RN, LPN) */
  MedicationAdminister = 'medication:administer',
  /** Read medication records */
  MedicationRead = 'medication:read',
  /** Read metadata */
  MetadataRead = 'metadata:read',
  /** Write metadata */
  MetadataWrite = 'metadata:write',
  /** Propose navigation changes (requires admin approval) */
  NavigationPropose = 'navigation:propose',
  /** Read navigation overrides */
  NavigationRead = 'navigation:read',
  /** Update navigation overrides (system architect) */
  NavigationWrite = 'navigation:write',
  /** Administer notifications */
  NotificationAdmin = 'notification:admin',
  /** Read notifications */
  NotificationRead = 'notification:read',
  /** Create/update notifications */
  NotificationWrite = 'notification:write',
  /** Dispatch orders - assign drivers, mark ready for pickup */
  OrderDispatch = 'order:dispatch',
  /** Create benefit configurations */
  PayrollBenefitCreate = 'payroll:benefit:create',
  /** Read benefit configurations */
  PayrollBenefitRead = 'payroll:benefit:read',
  /** Create payroll deductions */
  PayrollDeductionCreate = 'payroll:deduction:create',
  /** Read payroll deductions */
  PayrollDeductionRead = 'payroll:deduction:read',
  /** Create employee records */
  PayrollEmployeeCreate = 'payroll:employee:create',
  /** Read employee records */
  PayrollEmployeeRead = 'payroll:employee:read',
  /** View own employee profile */
  PayrollEmployeeSelf = 'payroll:employee:self',
  /** Update employee records */
  PayrollEmployeeUpdate = 'payroll:employee:update',
  /** Create leave requests */
  PayrollLeaveCreate = 'payroll:leave:create',
  /** Read leave requests/balances */
  PayrollLeaveRead = 'payroll:leave:read',
  /** Update leave requests (approve/deny) */
  PayrollLeaveUpdate = 'payroll:leave:update',
  /** Read payroll management data (admin) */
  PayrollManageRead = 'payroll:manage:read',
  /** Read all payroll data */
  PayrollRead = 'payroll:read',
  /** Approve payroll runs */
  PayrollRunApprove = 'payroll:run:approve',
  /** Create payroll runs */
  PayrollRunCreate = 'payroll:run:create',
  /** Read payroll runs */
  PayrollRunRead = 'payroll:run:read',
  /** Update payroll runs */
  PayrollRunUpdate = 'payroll:run:update',
  /** Create work schedules */
  PayrollScheduleCreate = 'payroll:schedule:create',
  /** Read work schedules */
  PayrollScheduleRead = 'payroll:schedule:read',
  /** Update work schedules */
  PayrollScheduleUpdate = 'payroll:schedule:update',
  /** Read own payroll data (self-service) */
  PayrollSelfRead = 'payroll:self:read',
  /** Read pay stubs */
  PayrollStubRead = 'payroll:stub:read',
  /** Create tax configurations */
  PayrollTaxCreate = 'payroll:tax:create',
  /** Read tax configurations */
  PayrollTaxRead = 'payroll:tax:read',
  /** Approve time entries (participant/supervisor) */
  PayrollTimeApprove = 'payroll:time:approve',
  /** Create time entries (clock in/out) */
  PayrollTimeCreate = 'payroll:time:create',
  /** Read time entries */
  PayrollTimeRead = 'payroll:time:read',
  /** Update time entries */
  PayrollTimeUpdate = 'payroll:time:update',
  /** Create timesheets */
  PayrollTimesheetCreate = 'payroll:timesheet:create',
  /** Read timesheets */
  PayrollTimesheetRead = 'payroll:timesheet:read',
  /** Write all payroll data */
  PayrollWrite = 'payroll:write',
  /** Full PII vault administration (read, import, audit) */
  PiiAdmin = 'pii:admin',
  /** Capture PII from camera/image (SSN cards, DL, insurance) */
  PiiCapture = 'pii:capture',
  /** Import PII via CLI with tenant attestation */
  PiiImport = 'pii:import',
  /** Read masked PII values (last 4 digits only) */
  PiiRead = 'pii:read',
  /** Full platform administration */
  PlatformAdmin = 'platform:admin',
  /** Platform debugging and diagnostics */
  PlatformDebug = 'platform:debug',
  /** Platform-wide search functionality */
  PlatformSearch = 'platform:search',
  /** Read policy primitives */
  PolicyRead = 'policy:read',
  /** Create/update policy primitives */
  PolicyWrite = 'policy:write',
  /** Activate products */
  ProductActivate = 'product:activate',
  /** Approve/reject config proposals (tenant admin) */
  ProposalApprove = 'proposal:approve',
  /** Cancel own proposals */
  ProposalCancel = 'proposal:cancel',
  /** Create config change proposals */
  ProposalCreate = 'proposal:create',
  /** Read config proposals */
  ProposalRead = 'proposal:read',
  /** Query provenance tracking — which configs created which primitives (DRR-145) */
  ProvenanceRead = 'provenance:read',
  /** Generate QAPI reports */
  QapiGenerate = 'qapi:generate',
  /** View QAPI dashboard (T3 data) */
  QapiView = 'qapi:view',
  /** Administer queues */
  QueueAdmin = 'queue:admin',
  /** Read queues */
  QueueRead = 'queue:read',
  /** Create/update queues */
  QueueWrite = 'queue:write',
  /** Approve regulatory changes and responses */
  RegulatoryApprove = 'regulatory:approve',
  /** Import regulatory data */
  RegulatoryImport = 'regulatory:import',
  /** Read regulatory data and rulesets */
  RegulatoryRead = 'regulatory:read',
  /** Generate reports */
  ReportGenerate = 'report:generate',
  /** Read resources */
  ResourceRead = 'resource:read',
  /** Create/update resources */
  ResourceWrite = 'resource:write',
  /** Administer roles */
  RoleAdmin = 'role:admin',
  /** Read role overrides for tenant */
  RoleOverrideRead = 'role:override:read',
  /** Create/update role overrides for tenant */
  RoleOverrideWrite = 'role:override:write',
  /** Read roles */
  RoleRead = 'role:read',
  /** Create/update roles */
  RoleWrite = 'role:write',
  /** Administer policies and rules */
  RulesAdmin = 'rules:admin',
  /** Read policies and rules */
  RulesRead = 'rules:read',
  /** Create/update policies and rules */
  RulesWrite = 'rules:write',
  /** Administer schedules */
  ScheduleAdmin = 'schedule:admin',
  /** Read schedules */
  ScheduleRead = 'schedule:read',
  /** Create/update schedules */
  ScheduleWrite = 'schedule:write',
  /** Administer scope edges and access permissions (DRR-329) */
  ScopeAdmin = 'scope:admin',
  /** Read scope definitions */
  ScopeRead = 'scope:read',
  /** Write scope definitions */
  ScopeWrite = 'scope:write',
  /** Propose setting changes (requires admin approval) */
  SettingsPropose = 'settings:propose',
  /** Read tenant settings */
  SettingsRead = 'settings:read',
  /** Update tenant settings (system architect) */
  SettingsWrite = 'settings:write',
  /** Manage shifts */
  ShiftManage = 'shift:manage',
  /** Read shift data */
  ShiftRead = 'shift:read',
  /** Record staff certifications (DRR-329: regulatory compliance) */
  StaffCertify = 'staff:certify',
  /** Manage staff — hiring, onboarding, performance, termination */
  StaffManage = 'staff:manage',
  /** Record staff training completion (DRR-329: regulatory compliance) */
  StaffTrain = 'staff:train',
  /** Operate kitchen station - view orders, update status */
  StationOperate = 'station:operate',
  /** Conduct supervision visits */
  SupervisionConduct = 'supervision:conduct',
  /** Respond to MDH survey inquiries and provide documentation */
  SurveyRespond = 'survey:respond',
  /** Read sync state */
  SyncRead = 'sync:read',
  /** Write sync state */
  SyncWrite = 'sync:write',
  /** Administer tasks */
  TaskAdmin = 'task:admin',
  /** Mark tasks as complete */
  TaskComplete = 'task:complete',
  /** Read tasks */
  TaskRead = 'task:read',
  /** Create/update tasks */
  TaskWrite = 'task:write',
  /** Propose task group changes (requires admin approval) */
  TaskgroupPropose = 'taskgroup:propose',
  /** Read task group definitions */
  TaskgroupRead = 'taskgroup:read',
  /** Create/update task groups (system architect) */
  TaskgroupWrite = 'taskgroup:write',
  /** Administer teams */
  TeamAdmin = 'team:admin',
  /** Read teams */
  TeamRead = 'team:read',
  /** Create/update teams */
  TeamWrite = 'team:write',
  /** Administer templates */
  TemplateAdmin = 'template:admin',
  /** Archive templates */
  TemplateArchive = 'template:archive',
  /** Create templates */
  TemplateCreate = 'template:create',
  /** Propose template changes (requires admin approval) */
  TemplatePropose = 'template:propose',
  /** Read templates */
  TemplateRead = 'template:read',
  /** Update templates */
  TemplateUpdate = 'template:update',
  /** Create/update templates */
  TemplateWrite = 'template:write',
  /** Full tenant administration */
  TenantAdmin = 'tenant:admin',
  /** Manage tenant configuration */
  TenantConfig = 'tenant:config',
  /** Read tenant configuration */
  TenantRead = 'tenant:read',
  /** Administer traces */
  TraceAdmin = 'trace:admin',
  /** Read traces */
  TraceRead = 'trace:read',
  /** Create/update traces */
  TraceWrite = 'trace:write',
  /** Manage staff training — assign, approve, track compliance */
  TrainingManage = 'training:manage',
  /** Read training records and compliance status */
  TrainingRead = 'training:read',
  /** View own training status and compliance */
  TrainingSelfRead = 'training:self:read',
  /** Write training data (complete modules, upload certs) */
  TrainingWrite = 'training:write',
  /** Administer transactions */
  TransactionAdmin = 'transaction:admin',
  /** Read transactions */
  TransactionRead = 'transaction:read',
  /** Create/update transactions */
  TransactionWrite = 'transaction:write',
  /** Administer validations */
  ValidationAdmin = 'validation:admin',
  /** Read validations */
  ValidationRead = 'validation:read',
  /** Create/update validations */
  ValidationWrite = 'validation:write',
  /** Read view context for navigation and UI rendering (DRR-288) */
  ViewRead = 'view:read',
  /** Read beacon data */
  WearablesBeaconRead = 'wearables:beacon:read',
  /** Read wearable captures */
  WearablesCaptureRead = 'wearables:capture:read',
  /** Read wearable commands */
  WearablesCommandRead = 'wearables:command:read',
  /** Read wearable device data */
  WearablesDeviceRead = 'wearables:device:read',
  /** Read proximity data */
  WearablesProximityRead = 'wearables:proximity:read',
  /** Read wearable readings (vitals) */
  WearablesReadingRead = 'wearables:reading:read',
  /** Read wearable sessions */
  WearablesSessionRead = 'wearables:session:read',
  /** Read website deployments */
  WebsiteDeploymentRead = 'website:deployment:read',
  /** Read website pages */
  WebsitePageRead = 'website:page:read',
  /** Administer workflows */
  WorkflowAdmin = 'workflow:admin',
  /** Create new workflows */
  WorkflowCreate = 'workflow:create',
  /** Fire workflow events */
  WorkflowFire = 'workflow:fire',
  /** Propose workflow changes (requires admin approval) */
  WorkflowPropose = 'workflow:propose',
  /** Read workflow definitions */
  WorkflowRead = 'workflow:read',
  /** Update existing workflows */
  WorkflowUpdate = 'workflow:update',
  /** Create/update workflow definitions */
  WorkflowWrite = 'workflow:write',
  /** Full workforce administration */
  WorkforceAdmin = 'workforce:admin',
  /** Read workforce data (team members, shifts, assignments) */
  WorkforceRead = 'workforce:read',
  /** Manage workforce assignments and scheduling */
  WorkforceWrite = 'workforce:write',
}

export interface ScopeMeta {
  id: string;
  description: string;
  wall: string | null;
  tier: string;
  category: string;
}

export const SCOPE_METADATA: Record<Scope, ScopeMeta> = {
  [Scope.AccountingCustomerCreate]: {
    id: 'accounting:customer:create',
    description: 'Create customer records',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingCustomerRead]: {
    id: 'accounting:customer:read',
    description: 'Read customer records',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingGlCreate]: {
    id: 'accounting:gl:create',
    description: 'Create GL accounts',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingGlRead]: {
    id: 'accounting:gl:read',
    description: 'Read general ledger',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingInvoiceCreate]: {
    id: 'accounting:invoice:create',
    description: 'Create invoices',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingInvoiceRead]: {
    id: 'accounting:invoice:read',
    description: 'Read invoices',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingJournalCreate]: {
    id: 'accounting:journal:create',
    description: 'Create journal entries',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingJournalRead]: {
    id: 'accounting:journal:read',
    description: 'Read journal entries',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingJournalUpdate]: {
    id: 'accounting:journal:update',
    description: 'Update journal entries',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingRead]: {
    id: 'accounting:read',
    description: 'Read all accounting data',
    wall: 'operational',
    tier: 'T2',
    category: 'accounting',
  },
  [Scope.AccountingVendorCreate]: {
    id: 'accounting:vendor:create',
    description: 'Create vendor records',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingVendorRead]: {
    id: 'accounting:vendor:read',
    description: 'Read vendor records',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingVendorUpdate]: {
    id: 'accounting:vendor:update',
    description: 'Update vendor records',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.AccountingWrite]: {
    id: 'accounting:write',
    description: 'Write all accounting data',
    wall: 'operational',
    tier: 'T2',
    category: 'accounting',
  },
  [Scope.ActorAdmin]: {
    id: 'actor:admin',
    description: 'Administer actor entities',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ActorRead]: {
    id: 'actor:read',
    description: 'Read actor entities',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ActorWrite]: {
    id: 'actor:write',
    description: 'Create/update actor entities',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.AdminAccess]: {
    id: 'admin:access',
    description: 'Basic admin layer access for navigation groups (DRR-283)',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.AdmissionManage]: {
    id: 'admission:manage',
    description: 'Manage admissions',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.AdvocacyGenerate]: {
    id: 'advocacy:generate',
    description: 'Generate advocacy reports (architect only)',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.AdvocacySubmit]: {
    id: 'advocacy:submit',
    description: 'Submit advocacy data',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.AdvocacyView]: {
    id: 'advocacy:view',
    description: 'View advocacy data',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.AnalyticsRead]: {
    id: 'analytics:read',
    description: 'Read analytics data',
    wall: null,
    tier: 'T2',
    category: 'analytics',
  },
  [Scope.AnalyticsView]: {
    id: 'analytics:view',
    description: 'View analytics dashboards',
    wall: null,
    tier: 'T2',
    category: 'analytics',
  },
  [Scope.AnalyticsWrite]: {
    id: 'analytics:write',
    description: 'Write analytics data',
    wall: null,
    tier: 'T2',
    category: 'analytics',
  },
  [Scope.AnnotationAdmin]: {
    id: 'annotation:admin',
    description: 'Administer annotations',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.AnnotationRead]: {
    id: 'annotation:read',
    description: 'Read annotations',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.AnnotationWrite]: {
    id: 'annotation:write',
    description: 'Write annotations',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ApprovalAdmin]: {
    id: 'approval:admin',
    description: 'Administer approvals',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ApprovalCreate]: {
    id: 'approval:create',
    description: 'Create approval requests',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ApprovalRead]: {
    id: 'approval:read',
    description: 'Read approvals',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ApprovalWrite]: {
    id: 'approval:write',
    description: 'Create/update approvals',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.AssessmentDismiss]: {
    id: 'assessment:dismiss',
    description: 'Dismiss assessments',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.AssessmentManage]: {
    id: 'assessment:manage',
    description: 'Manage assessments',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.AssessmentRead]: {
    id: 'assessment:read',
    description: 'Read assessments',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.AssessmentReport]: {
    id: 'assessment:report',
    description: 'Generate assessment reports',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.AssessmentStore]: {
    id: 'assessment:store',
    description: 'Store signed assessments (DRR-329: clinical documentation)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.AssistantQuery]: {
    id: 'assistant:query',
    description: 'Query AI assistant',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.AuditRead]: {
    id: 'audit:read',
    description: 'Read audit logs',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.AuthMfa]: {
    id: 'auth:mfa',
    description: 'MFA operations',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.AuthRead]: {
    id: 'auth:read',
    description: 'Read auth configuration',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.BillingRead]: {
    id: 'billing:read',
    description: 'Read billing/insurance data (field-level visibility)',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.BillingWrite]: {
    id: 'billing:write',
    description: 'Write billing/insurance data',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.CarePlanApprove]: {
    id: 'care_plan:approve',
    description: 'Approve care plans (ALD, DoN, CEO)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.CarePlanCreate]: {
    id: 'care_plan:create',
    description: 'Create care plans (RN, QP)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.CarePlanRead]: {
    id: 'care_plan:read',
    description: 'Read care plans',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.CfssAgency]: {
    id: 'cfss:agency',
    description: 'CFSS agency provider — coordinate services',
    wall: 'operational',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.CfssParticipant]: {
    id: 'cfss:participant',
    description: 'CFSS participant — view own services, select workers',
    wall: null,
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.CfssQp]: {
    id: 'cfss:qp',
    description: 'CFSS qualified professional — clinical oversight',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.CfssWorker]: {
    id: 'cfss:worker',
    description: 'CFSS support worker — relationship-filtered access',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.CheckpointAdmin]: {
    id: 'checkpoint:admin',
    description: 'Administer checkpoints',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.CheckpointRead]: {
    id: 'checkpoint:read',
    description: 'Read checkpoints',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.CheckpointWrite]: {
    id: 'checkpoint:write',
    description: 'Create/update checkpoints',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ClinicalFull]: {
    id: 'clinical:full',
    description: 'Full clinical access',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.ClinicalRead]: {
    id: 'clinical:read',
    description: 'Read clinical data',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.ClinicalStandard]: {
    id: 'clinical:standard',
    description: 'Standard clinical operations',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.ClinicalWrite]: {
    id: 'clinical:write',
    description: 'Write clinical data (FHIR status updates, care plan modifications)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.ComplianceManage]: {
    id: 'compliance:manage',
    description: 'Manage compliance workflows',
    wall: 'operational',
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.ComplianceRead]: {
    id: 'compliance:read',
    description: 'Read compliance data',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.ComplianceWrite]: {
    id: 'compliance:write',
    description: 'Write compliance data',
    wall: 'operational',
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.CompositionRead]: {
    id: 'composition:read',
    description: 'Read compositions',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.CompositionWrite]: {
    id: 'composition:write',
    description: 'Write compositions',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.ConfigRead]: {
    id: 'config:read',
    description: 'Read configuration',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.ConstraintAdmin]: {
    id: 'constraint:admin',
    description: 'Administer constraints',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ConstraintRead]: {
    id: 'constraint:read',
    description: 'Read constraints',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ConstraintWrite]: {
    id: 'constraint:write',
    description: 'Create/update constraints',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ContractAdmin]: {
    id: 'contract:admin',
    description: 'Administer contracts',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ContractRead]: {
    id: 'contract:read',
    description: 'Read contracts',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ContractWrite]: {
    id: 'contract:write',
    description: 'Create/update contracts',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.CoordinationRead]: {
    id: 'coordination:read',
    description: 'Read coordination data',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.DelegationManage]: {
    id: 'delegation:manage',
    description: 'Manage clinical delegation (144G.71) — assign ULP to tasks, verify competency',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.DeliveryView]: {
    id: 'delivery:view',
    description: 'View delivery assignments and route info',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.DependencyAdmin]: {
    id: 'dependency:admin',
    description: 'Administer dependencies',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.DependencyRead]: {
    id: 'dependency:read',
    description: 'Read dependencies',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.DependencyWrite]: {
    id: 'dependency:write',
    description: 'Create/update dependencies',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.DocumentAdmin]: {
    id: 'document:admin',
    description: 'Administer documents',
    wall: null,
    tier: 'T2',
    category: 'document',
  },
  [Scope.DocumentEncrypt]: {
    id: 'document:encrypt',
    description: 'Encrypt documents',
    wall: null,
    tier: 'T2',
    category: 'document',
  },
  [Scope.DocumentGenerate]: {
    id: 'document:generate',
    description: 'Generate documents (PDF, etc.)',
    wall: null,
    tier: 'T2',
    category: 'document',
  },
  [Scope.DocumentRead]: {
    id: 'document:read',
    description: 'Read documents',
    wall: null,
    tier: 'T2',
    category: 'document',
  },
  [Scope.DocumentSign]: {
    id: 'document:sign',
    description: 'Sign documents',
    wall: null,
    tier: 'T2',
    category: 'document',
  },
  [Scope.DocumentWrite]: {
    id: 'document:write',
    description: 'Create/update documents',
    wall: null,
    tier: 'T2',
    category: 'document',
  },
  [Scope.DonAll]: {
    id: 'don:all',
    description: 'Director of Nursing full access',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.EdiClaimRead]: {
    id: 'edi:claim:read',
    description: 'Read EDI claims',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.EdiRead]: {
    id: 'edi:read',
    description: 'Read all EDI data',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.EdiTransactionRead]: {
    id: 'edi:transaction:read',
    description: 'Read EDI transactions',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.EdiWrite]: {
    id: 'edi:write',
    description: 'Write all EDI data',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.EmergencyBlockRead]: {
    id: 'emergency:block:read',
    description: 'View active emergency blocks on actors/roles',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.EmergencyBlockWrite]: {
    id: 'emergency:block:write',
    description: 'Create/extend/remove emergency blocks (subtractive access revocation)',
    wall: null,
    tier: 'T3',
    category: 'platform',
  },
  [Scope.EnrollmentCreate]: {
    id: 'enrollment:create',
    description: 'Create enrollments',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.ErpRead]: {
    id: 'erp:read',
    description: 'Read all ERP data',
    wall: 'operational',
    tier: 'T2',
    category: 'erp',
  },
  [Scope.ErpWrite]: {
    id: 'erp:write',
    description: 'Write all ERP data',
    wall: 'operational',
    tier: 'T2',
    category: 'erp',
  },
  [Scope.EventRead]: {
    id: 'event:read',
    description: 'Read events',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.EventWrite]: {
    id: 'event:write',
    description: 'Create/update events',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ExchangeAdmin]: {
    id: 'exchange:admin',
    description: 'Administer exchange',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.ExchangePush]: {
    id: 'exchange:push',
    description: 'Push to exchange',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.ExchangeRead]: {
    id: 'exchange:read',
    description: 'Read exchange data',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.ExchangeRevoke]: {
    id: 'exchange:revoke',
    description: 'Revoke exchange access',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.FacilityAdmin]: {
    id: 'facility:admin',
    description: 'Facility-level administration (ALD oversight of all subjects)',
    wall: 'operational',
    tier: 'T2',
    category: 'platform',
  },
  [Scope.FederationRead]: {
    id: 'federation:read',
    description: 'Read federation data',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.FhirAllergyintoleranceCreate]: {
    id: 'fhir:allergyintolerance:create',
    description: 'Create FHIR AllergyIntolerance resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirAllergyintoleranceRead]: {
    id: 'fhir:allergyintolerance:read',
    description: 'Read FHIR AllergyIntolerance resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirCareplanCreate]: {
    id: 'fhir:careplan:create',
    description: 'Create FHIR CarePlan resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirCareplanRead]: {
    id: 'fhir:careplan:read',
    description: 'Read FHIR CarePlan resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirCareplanUpdate]: {
    id: 'fhir:careplan:update',
    description: 'Update FHIR CarePlan resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirCareteamCreate]: {
    id: 'fhir:careteam:create',
    description: 'Create FHIR CareTeam resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirCareteamRead]: {
    id: 'fhir:careteam:read',
    description: 'Read FHIR CareTeam resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirClaimCreate]: {
    id: 'fhir:claim:create',
    description: 'Create FHIR Claim resources',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.FhirClaimRead]: {
    id: 'fhir:claim:read',
    description: 'Read FHIR Claim resources',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.FhirClaimUpdate]: {
    id: 'fhir:claim:update',
    description: 'Update FHIR Claim resources',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.FhirClaimresponseRead]: {
    id: 'fhir:claimresponse:read',
    description: 'Read FHIR ClaimResponse resources (adjudication)',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.FhirConditionCreate]: {
    id: 'fhir:condition:create',
    description: 'Create FHIR Condition resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirConditionRead]: {
    id: 'fhir:condition:read',
    description: 'Read FHIR Condition resources (diagnoses)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirDiagnosticRead]: {
    id: 'fhir:diagnostic:read',
    description: 'Read FHIR DiagnosticReport resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirEncounterCreate]: {
    id: 'fhir:encounter:create',
    description: 'Create FHIR Encounter resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirEncounterRead]: {
    id: 'fhir:encounter:read',
    description: 'Read FHIR Encounter resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirMedicationPrescribe]: {
    id: 'fhir:medication:prescribe',
    description: 'Prescribe medications (licensed staff)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirMedicationRead]: {
    id: 'fhir:medication:read',
    description: 'Read FHIR Medication resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirMedicationadministrationCreate]: {
    id: 'fhir:medicationadministration:create',
    description: 'Create FHIR MedicationAdministration records',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirMedicationadministrationRead]: {
    id: 'fhir:medicationadministration:read',
    description: 'Read FHIR MedicationAdministration resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirMedicationrequestCreate]: {
    id: 'fhir:medicationrequest:create',
    description: 'Create FHIR MedicationRequest resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirMedicationrequestRead]: {
    id: 'fhir:medicationrequest:read',
    description: 'Read FHIR MedicationRequest resources (orders)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirMedicationstatementRead]: {
    id: 'fhir:medicationstatement:read',
    description: 'Read FHIR MedicationStatement resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirObservationCreate]: {
    id: 'fhir:observation:create',
    description: 'Create FHIR Observation resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirObservationRead]: {
    id: 'fhir:observation:read',
    description: 'Read FHIR Observation resources (vitals, ADLs)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirPatientCreate]: {
    id: 'fhir:patient:create',
    description: 'Create FHIR Patient resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirPatientRead]: {
    id: 'fhir:patient:read',
    description: 'Read FHIR Patient resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirPatientUpdate]: {
    id: 'fhir:patient:update',
    description: 'Update FHIR Patient resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirPractitionerRead]: {
    id: 'fhir:practitioner:read',
    description: 'Read FHIR Practitioner resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirPractitionerroleRead]: {
    id: 'fhir:practitionerrole:read',
    description: 'Read FHIR PractitionerRole resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirProcedureCreate]: {
    id: 'fhir:procedure:create',
    description: 'Create FHIR Procedure resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirProcedureRead]: {
    id: 'fhir:procedure:read',
    description: 'Read FHIR Procedure resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirRead]: {
    id: 'fhir:read',
    description: 'Read all FHIR resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FhirWrite]: {
    id: 'fhir:write',
    description: 'Write all FHIR resources',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.FoodServiceCook]: {
    id: 'food-service:cook',
    description: 'Line cook station access - view and update orders',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.FoodServiceDriver]: {
    id: 'food-service:driver',
    description: 'Driver access - view deliveries, mark delivered',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.FoodServiceExpo]: {
    id: 'food-service:expo',
    description: 'Expeditor access - QC, dispatch, driver assignment',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.FoodServiceManager]: {
    id: 'food-service:manager',
    description: 'Kitchen manager - full operations access',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.FormsRead]: {
    id: 'forms:read',
    description: 'Read form schemas',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.FormsWrite]: {
    id: 'forms:write',
    description: 'Write form schemas',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.FormschemaPropose]: {
    id: 'formschema:propose',
    description: 'Propose form schema changes (requires admin approval)',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.FormschemaRead]: {
    id: 'formschema:read',
    description: 'Read form schema definitions',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.FormschemaWrite]: {
    id: 'formschema:write',
    description: 'Create/update form schemas (system architect)',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.GraphRead]: {
    id: 'graph:read',
    description: 'Read graph data',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.IncidentInvestigate]: {
    id: 'incident:investigate',
    description: 'Investigate incidents (ALD, DoN, CEO)',
    wall: 'clinical',
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.IncidentRead]: {
    id: 'incident:read',
    description: 'Read incident reports',
    wall: 'clinical',
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.IncidentReport]: {
    id: 'incident:report',
    description: 'Create incident reports',
    wall: 'clinical',
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.InstanceAdmin]: {
    id: 'instance:admin',
    description: 'Administer workflow instances',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.InstanceRead]: {
    id: 'instance:read',
    description: 'Read workflow instances',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.InstanceWrite]: {
    id: 'instance:write',
    description: 'Create/update workflow instances',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.IntegrationInvoke]: {
    id: 'integration:invoke',
    description: 'Invoke external integrations (DRR-329)',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.IntegrationRead]: {
    id: 'integration:read',
    description: 'Read integration configurations',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.IntegrationWrite]: {
    id: 'integration:write',
    description: 'Create/update integrations',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.KitchenManage]: {
    id: 'kitchen:manage',
    description: 'Kitchen operations management - staffing, inventory, compliance',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.LedgerRead]: {
    id: 'ledger:read',
    description: 'Read ledger entries',
    wall: null,
    tier: 'T2',
    category: 'financial',
  },
  [Scope.LedgerWrite]: {
    id: 'ledger:write',
    description: 'Write ledger entries',
    wall: null,
    tier: 'T2',
    category: 'financial',
  },
  [Scope.LifecycleManage]: {
    id: 'lifecycle:manage',
    description: 'Create and fire lifecycle instances (subject lifecycle transitions)',
    wall: 'operational',
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.McpAccess]: {
    id: 'mcp:access',
    description: 'Access MCP tools and resources (ingest events, generate summaries)',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.McpAdmin]: {
    id: 'mcp:admin',
    description: 'Administer MCP settings (toggle embedded/standalone, thresholds)',
    wall: null,
    tier: 'T3',
    category: 'platform',
  },
  [Scope.MedicationAdmin]: {
    id: 'medication:admin',
    description: 'Full medication administration (licensed staff only — RN/LPN)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.MedicationAdminDelegated]: {
    id: 'medication:admin_delegated',
    description: 'Delegated medication administration (ULP under 144G.71)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.MedicationAdminister]: {
    id: 'medication:administer',
    description: 'Administer medications to residents (delegated ULP, Med Aide, RN, LPN)',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.MedicationRead]: {
    id: 'medication:read',
    description: 'Read medication records',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.MetadataRead]: {
    id: 'metadata:read',
    description: 'Read metadata',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.MetadataWrite]: {
    id: 'metadata:write',
    description: 'Write metadata',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.NavigationPropose]: {
    id: 'navigation:propose',
    description: 'Propose navigation changes (requires admin approval)',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.NavigationRead]: {
    id: 'navigation:read',
    description: 'Read navigation overrides',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.NavigationWrite]: {
    id: 'navigation:write',
    description: 'Update navigation overrides (system architect)',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.NotificationAdmin]: {
    id: 'notification:admin',
    description: 'Administer notifications',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.NotificationRead]: {
    id: 'notification:read',
    description: 'Read notifications',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.NotificationWrite]: {
    id: 'notification:write',
    description: 'Create/update notifications',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.OrderDispatch]: {
    id: 'order:dispatch',
    description: 'Dispatch orders - assign drivers, mark ready for pickup',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.PayrollBenefitCreate]: {
    id: 'payroll:benefit:create',
    description: 'Create benefit configurations',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollBenefitRead]: {
    id: 'payroll:benefit:read',
    description: 'Read benefit configurations',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollDeductionCreate]: {
    id: 'payroll:deduction:create',
    description: 'Create payroll deductions',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollDeductionRead]: {
    id: 'payroll:deduction:read',
    description: 'Read payroll deductions',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollEmployeeCreate]: {
    id: 'payroll:employee:create',
    description: 'Create employee records',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollEmployeeRead]: {
    id: 'payroll:employee:read',
    description: 'Read employee records',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollEmployeeSelf]: {
    id: 'payroll:employee:self',
    description: 'View own employee profile',
    wall: null,
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollEmployeeUpdate]: {
    id: 'payroll:employee:update',
    description: 'Update employee records',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollLeaveCreate]: {
    id: 'payroll:leave:create',
    description: 'Create leave requests',
    wall: null,
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollLeaveRead]: {
    id: 'payroll:leave:read',
    description: 'Read leave requests/balances',
    wall: null,
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollLeaveUpdate]: {
    id: 'payroll:leave:update',
    description: 'Update leave requests (approve/deny)',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollManageRead]: {
    id: 'payroll:manage:read',
    description: 'Read payroll management data (admin)',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollRead]: {
    id: 'payroll:read',
    description: 'Read all payroll data',
    wall: 'operational',
    tier: 'T2',
    category: 'payroll',
  },
  [Scope.PayrollRunApprove]: {
    id: 'payroll:run:approve',
    description: 'Approve payroll runs',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollRunCreate]: {
    id: 'payroll:run:create',
    description: 'Create payroll runs',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollRunRead]: {
    id: 'payroll:run:read',
    description: 'Read payroll runs',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollRunUpdate]: {
    id: 'payroll:run:update',
    description: 'Update payroll runs',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollScheduleCreate]: {
    id: 'payroll:schedule:create',
    description: 'Create work schedules',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollScheduleRead]: {
    id: 'payroll:schedule:read',
    description: 'Read work schedules',
    wall: null,
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollScheduleUpdate]: {
    id: 'payroll:schedule:update',
    description: 'Update work schedules',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollSelfRead]: {
    id: 'payroll:self:read',
    description: 'Read own payroll data (self-service)',
    wall: null,
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollStubRead]: {
    id: 'payroll:stub:read',
    description: 'Read pay stubs',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollTaxCreate]: {
    id: 'payroll:tax:create',
    description: 'Create tax configurations',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollTaxRead]: {
    id: 'payroll:tax:read',
    description: 'Read tax configurations',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollTimeApprove]: {
    id: 'payroll:time:approve',
    description: 'Approve time entries (participant/supervisor)',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollTimeCreate]: {
    id: 'payroll:time:create',
    description: 'Create time entries (clock in/out)',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollTimeRead]: {
    id: 'payroll:time:read',
    description: 'Read time entries',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollTimeUpdate]: {
    id: 'payroll:time:update',
    description: 'Update time entries',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollTimesheetCreate]: {
    id: 'payroll:timesheet:create',
    description: 'Create timesheets',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollTimesheetRead]: {
    id: 'payroll:timesheet:read',
    description: 'Read timesheets',
    wall: 'operational',
    tier: 'T2',
    category: 'financial',
  },
  [Scope.PayrollWrite]: {
    id: 'payroll:write',
    description: 'Write all payroll data',
    wall: 'operational',
    tier: 'T2',
    category: 'payroll',
  },
  [Scope.PiiAdmin]: {
    id: 'pii:admin',
    description: 'Full PII vault administration (read, import, audit)',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.PiiCapture]: {
    id: 'pii:capture',
    description: 'Capture PII from camera/image (SSN cards, DL, insurance)',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.PiiImport]: {
    id: 'pii:import',
    description: 'Import PII via CLI with tenant attestation',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.PiiRead]: {
    id: 'pii:read',
    description: 'Read masked PII values (last 4 digits only)',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.PlatformAdmin]: {
    id: 'platform:admin',
    description: 'Full platform administration',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.PlatformDebug]: {
    id: 'platform:debug',
    description: 'Platform debugging and diagnostics',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.PlatformSearch]: {
    id: 'platform:search',
    description: 'Platform-wide search functionality',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.PolicyRead]: {
    id: 'policy:read',
    description: 'Read policy primitives',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.PolicyWrite]: {
    id: 'policy:write',
    description: 'Create/update policy primitives',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ProductActivate]: {
    id: 'product:activate',
    description: 'Activate products',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.ProposalApprove]: {
    id: 'proposal:approve',
    description: 'Approve/reject config proposals (tenant admin)',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.ProposalCancel]: {
    id: 'proposal:cancel',
    description: 'Cancel own proposals',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.ProposalCreate]: {
    id: 'proposal:create',
    description: 'Create config change proposals',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.ProposalRead]: {
    id: 'proposal:read',
    description: 'Read config proposals',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.ProvenanceRead]: {
    id: 'provenance:read',
    description: 'Query provenance tracking — which configs created which primitives (DRR-145)',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.QapiGenerate]: {
    id: 'qapi:generate',
    description: 'Generate QAPI reports',
    wall: 'clinical',
    tier: 'T3',
    category: 'clinical',
  },
  [Scope.QapiView]: {
    id: 'qapi:view',
    description: 'View QAPI dashboard (T3 data)',
    wall: 'clinical',
    tier: 'T3',
    category: 'clinical',
  },
  [Scope.QueueAdmin]: {
    id: 'queue:admin',
    description: 'Administer queues',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.QueueRead]: {
    id: 'queue:read',
    description: 'Read queues',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.QueueWrite]: {
    id: 'queue:write',
    description: 'Create/update queues',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.RegulatoryApprove]: {
    id: 'regulatory:approve',
    description: 'Approve regulatory changes and responses',
    wall: 'operational',
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.RegulatoryImport]: {
    id: 'regulatory:import',
    description: 'Import regulatory data',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.RegulatoryRead]: {
    id: 'regulatory:read',
    description: 'Read regulatory data and rulesets',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.ReportGenerate]: {
    id: 'report:generate',
    description: 'Generate reports',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.ResourceRead]: {
    id: 'resource:read',
    description: 'Read resources',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ResourceWrite]: {
    id: 'resource:write',
    description: 'Create/update resources',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.RoleAdmin]: {
    id: 'role:admin',
    description: 'Administer roles',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.RoleOverrideRead]: {
    id: 'role:override:read',
    description: 'Read role overrides for tenant',
    wall: null,
    tier: 'T2',
    category: 'config',
  },
  [Scope.RoleOverrideWrite]: {
    id: 'role:override:write',
    description: 'Create/update role overrides for tenant',
    wall: null,
    tier: 'T2',
    category: 'config',
  },
  [Scope.RoleRead]: {
    id: 'role:read',
    description: 'Read roles',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.RoleWrite]: {
    id: 'role:write',
    description: 'Create/update roles',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.RulesAdmin]: {
    id: 'rules:admin',
    description: 'Administer policies and rules',
    wall: 'operational',
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.RulesRead]: {
    id: 'rules:read',
    description: 'Read policies and rules',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.RulesWrite]: {
    id: 'rules:write',
    description: 'Create/update policies and rules',
    wall: 'operational',
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.ScheduleAdmin]: {
    id: 'schedule:admin',
    description: 'Administer schedules',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ScheduleRead]: {
    id: 'schedule:read',
    description: 'Read schedules',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ScheduleWrite]: {
    id: 'schedule:write',
    description: 'Create/update schedules',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ScopeAdmin]: {
    id: 'scope:admin',
    description: 'Administer scope edges and access permissions (DRR-329)',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.ScopeRead]: {
    id: 'scope:read',
    description: 'Read scope definitions',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.ScopeWrite]: {
    id: 'scope:write',
    description: 'Write scope definitions',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.SettingsPropose]: {
    id: 'settings:propose',
    description: 'Propose setting changes (requires admin approval)',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.SettingsRead]: {
    id: 'settings:read',
    description: 'Read tenant settings',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.SettingsWrite]: {
    id: 'settings:write',
    description: 'Update tenant settings (system architect)',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.ShiftManage]: {
    id: 'shift:manage',
    description: 'Manage shifts',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ShiftRead]: {
    id: 'shift:read',
    description: 'Read shift data',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.StaffCertify]: {
    id: 'staff:certify',
    description: 'Record staff certifications (DRR-329: regulatory compliance)',
    wall: 'operational',
    tier: 'T2',
    category: 'platform',
  },
  [Scope.StaffManage]: {
    id: 'staff:manage',
    description: 'Manage staff — hiring, onboarding, performance, termination',
    wall: 'operational',
    tier: 'T2',
    category: 'platform',
  },
  [Scope.StaffTrain]: {
    id: 'staff:train',
    description: 'Record staff training completion (DRR-329: regulatory compliance)',
    wall: 'operational',
    tier: 'T2',
    category: 'platform',
  },
  [Scope.StationOperate]: {
    id: 'station:operate',
    description: 'Operate kitchen station - view orders, update status',
    wall: 'operational',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.SupervisionConduct]: {
    id: 'supervision:conduct',
    description: 'Conduct supervision visits',
    wall: 'clinical',
    tier: 'T2',
    category: 'clinical',
  },
  [Scope.SurveyRespond]: {
    id: 'survey:respond',
    description: 'Respond to MDH survey inquiries and provide documentation',
    wall: 'operational',
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.SyncRead]: {
    id: 'sync:read',
    description: 'Read sync state',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.SyncWrite]: {
    id: 'sync:write',
    description: 'Write sync state',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.TaskAdmin]: {
    id: 'task:admin',
    description: 'Administer tasks',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TaskComplete]: {
    id: 'task:complete',
    description: 'Mark tasks as complete',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TaskRead]: {
    id: 'task:read',
    description: 'Read tasks',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TaskWrite]: {
    id: 'task:write',
    description: 'Create/update tasks',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TaskgroupPropose]: {
    id: 'taskgroup:propose',
    description: 'Propose task group changes (requires admin approval)',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.TaskgroupRead]: {
    id: 'taskgroup:read',
    description: 'Read task group definitions',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.TaskgroupWrite]: {
    id: 'taskgroup:write',
    description: 'Create/update task groups (system architect)',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.TeamAdmin]: {
    id: 'team:admin',
    description: 'Administer teams',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TeamRead]: {
    id: 'team:read',
    description: 'Read teams',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TeamWrite]: {
    id: 'team:write',
    description: 'Create/update teams',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TemplateAdmin]: {
    id: 'template:admin',
    description: 'Administer templates',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TemplateArchive]: {
    id: 'template:archive',
    description: 'Archive templates',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TemplateCreate]: {
    id: 'template:create',
    description: 'Create templates',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TemplatePropose]: {
    id: 'template:propose',
    description: 'Propose template changes (requires admin approval)',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.TemplateRead]: {
    id: 'template:read',
    description: 'Read templates',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TemplateUpdate]: {
    id: 'template:update',
    description: 'Update templates',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TemplateWrite]: {
    id: 'template:write',
    description: 'Create/update templates',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TenantAdmin]: {
    id: 'tenant:admin',
    description: 'Full tenant administration',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.TenantConfig]: {
    id: 'tenant:config',
    description: 'Manage tenant configuration',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.TenantRead]: {
    id: 'tenant:read',
    description: 'Read tenant configuration',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.TraceAdmin]: {
    id: 'trace:admin',
    description: 'Administer traces',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TraceRead]: {
    id: 'trace:read',
    description: 'Read traces',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TraceWrite]: {
    id: 'trace:write',
    description: 'Create/update traces',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TrainingManage]: {
    id: 'training:manage',
    description: 'Manage staff training — assign, approve, track compliance',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.TrainingRead]: {
    id: 'training:read',
    description: 'Read training records and compliance status',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.TrainingSelfRead]: {
    id: 'training:self:read',
    description: 'View own training status and compliance',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.TrainingWrite]: {
    id: 'training:write',
    description: 'Write training data (complete modules, upload certs)',
    wall: null,
    tier: 'T2',
    category: 'compliance',
  },
  [Scope.TransactionAdmin]: {
    id: 'transaction:admin',
    description: 'Administer transactions',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TransactionRead]: {
    id: 'transaction:read',
    description: 'Read transactions',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.TransactionWrite]: {
    id: 'transaction:write',
    description: 'Create/update transactions',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ValidationAdmin]: {
    id: 'validation:admin',
    description: 'Administer validations',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ValidationRead]: {
    id: 'validation:read',
    description: 'Read validations',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ValidationWrite]: {
    id: 'validation:write',
    description: 'Create/update validations',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.ViewRead]: {
    id: 'view:read',
    description: 'Read view context for navigation and UI rendering (DRR-288)',
    wall: null,
    tier: 'T1',
    category: 'platform',
  },
  [Scope.WearablesBeaconRead]: {
    id: 'wearables:beacon:read',
    description: 'Read beacon data',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.WearablesCaptureRead]: {
    id: 'wearables:capture:read',
    description: 'Read wearable captures',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.WearablesCommandRead]: {
    id: 'wearables:command:read',
    description: 'Read wearable commands',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.WearablesDeviceRead]: {
    id: 'wearables:device:read',
    description: 'Read wearable device data',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.WearablesProximityRead]: {
    id: 'wearables:proximity:read',
    description: 'Read proximity data',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.WearablesReadingRead]: {
    id: 'wearables:reading:read',
    description: 'Read wearable readings (vitals)',
    wall: 'clinical',
    tier: 'T2',
    category: 'integration',
  },
  [Scope.WearablesSessionRead]: {
    id: 'wearables:session:read',
    description: 'Read wearable sessions',
    wall: null,
    tier: 'T2',
    category: 'integration',
  },
  [Scope.WebsiteDeploymentRead]: {
    id: 'website:deployment:read',
    description: 'Read website deployments',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.WebsitePageRead]: {
    id: 'website:page:read',
    description: 'Read website pages',
    wall: null,
    tier: 'T2',
    category: 'platform',
  },
  [Scope.WorkflowAdmin]: {
    id: 'workflow:admin',
    description: 'Administer workflows',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.WorkflowCreate]: {
    id: 'workflow:create',
    description: 'Create new workflows',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.WorkflowFire]: {
    id: 'workflow:fire',
    description: 'Fire workflow events',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.WorkflowPropose]: {
    id: 'workflow:propose',
    description: 'Propose workflow changes (requires admin approval)',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.WorkflowRead]: {
    id: 'workflow:read',
    description: 'Read workflow definitions',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.WorkflowUpdate]: {
    id: 'workflow:update',
    description: 'Update existing workflows',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.WorkflowWrite]: {
    id: 'workflow:write',
    description: 'Create/update workflow definitions',
    wall: null,
    tier: 'T2',
    category: 'workflow',
  },
  [Scope.WorkforceAdmin]: {
    id: 'workforce:admin',
    description: 'Full workforce administration',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.WorkforceRead]: {
    id: 'workforce:read',
    description: 'Read workforce data (team members, shifts, assignments)',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
  [Scope.WorkforceWrite]: {
    id: 'workforce:write',
    description: 'Manage workforce assignments and scheduling',
    wall: null,
    tier: 'T2',
    category: 'primitive',
  },
};

// ══════════════════════════════════════════════════════════════════════════════
// COMPLIANCE FRAMEWORKS
// ══════════════════════════════════════════════════════════════════════════════

export enum ComplianceFramework {
  /** Affordable Care Act Employer Mandate */
  ACA = 'ACA',
  /** Americans with Disabilities Act */
  ADA = 'ADA',
  /** ANSI Accredited Standards Committee X12 */
  ANSI_X12 = 'ANSI_X12',
  /** CAP Laboratory Critical Value Standards */
  CAP_CRITICAL_VALUES = 'CAP_CRITICAL_VALUES',
  /** California Consumer Privacy Act */
  CCPA = 'CCPA',
  /** Consumer Credit Protection Act — Garnishment */
  CCPA_GARNISHMENT = 'CCPA_GARNISHMENT',
  /** CDC Vaccine Administered Codes */
  CDC_CVX = 'CDC_CVX',
  /** CDC Immunization Information System Standards */
  CDC_IIS = 'CDC_IIS',
  /** CDC Vaccine Manufacturer Codes */
  CDC_MVX = 'CDC_MVX',
  /** CDC Clinical Practice Guideline for Prescribing Opioids */
  CDC_OPIOID_GUIDELINE = 'CDC_OPIOID_GUIDELINE',
  /** 42 CFR Part 2 Substance Use Disorder Confidentiality */
  CFR_PART2 = 'CFR_PART2',
  /** Clinical Laboratory Improvement Amendments */
  CLIA = 'CLIA',
  /** CMS-1500 Health Insurance Claim Form */
  CMS_1500 = 'CMS_1500',
  /** CMS Interoperability & Prior Authorization Final Rule */
  CMS_CMS9115 = 'CMS_CMS9115',
  /** CMS Conditions of Participation */
  CMS_COP = 'CMS_COP',
  /** CMS HCBS Settings Rule */
  CMS_HCBS_SETTINGS = 'CMS_HCBS_SETTINGS',
  /** CMS HEDIS & MIPS Quality Reporting Measures */
  CMS_HEDIS_MIPS = 'CMS_HEDIS_MIPS',
  /** CMS Medicare Part D Prescription Drug Benefit */
  CMS_PART_D = 'CMS_PART_D',
  /** CMS Medicare Star Ratings Program */
  CMS_STAR_RATINGS = 'CMS_STAR_RATINGS',
  /** Consolidated Omnibus Budget Reconciliation Act */
  COBRA = 'COBRA',
  /** Care Providers of Minnesota Standards */
  CPMN = 'CPMN',
  /** Davis-Bacon and Related Acts */
  DAVIS_BACON = 'DAVIS_BACON',
  /** DEA Controlled Substances Act */
  DEA_CONTROLLED_SUBSTANCES = 'DEA_CONTROLLED_SUBSTANCES',
  /** DEA Registration Number */
  DEA_NUMBER = 'DEA_NUMBER',
  /** Equal Employment Opportunity Commission Requirements */
  EEOC = 'EEOC',
  /** Electronic Prescribing of Controlled Substances */
  EPCS = 'EPCS',
  /** Employee Retirement Income Security Act */
  ERISA = 'ERISA',
  /** FDA 21 CFR Part 11 - Electronic Records */
  FDA_21_CFR_Part_11 = 'FDA_21_CFR_Part_11',
  /** FDA DailyMed Drug Labeling */
  FDA_DRUG_LABELING = 'FDA_DRUG_LABELING',
  /** FDA Drug Establishment Registration and Listing */
  FDA_DRUG_LISTING = 'FDA_DRUG_LISTING',
  /** FDA Drug Safety & REMS Program Requirements */
  FDA_DRUG_SAFETY = 'FDA_DRUG_SAFETY',
  /** FDA Adverse Event Reporting System */
  FDA_FAERS = 'FDA_FAERS',
  /** FDA Risk Evaluation and Mitigation Strategies */
  FDA_REMS = 'FDA_REMS',
  /** FDA Unique Ingredient Identifier */
  FDA_UNII = 'FDA_UNII',
  /** FERP Internal Compliance Standards */
  FERP_INTERNAL = 'FERP_INTERNAL',
  /** FHIR Release 4 (alias) */
  FHIR_R4 = 'FHIR_R4',
  /** Fair Labor Standards Act */
  FLSA = 'FLSA',
  /** Family and Medical Leave Act */
  FMLA = 'FMLA',
  /** Generally Accepted Accounting Principles */
  GAAP = 'GAAP',
  /** General Data Protection Regulation */
  GDPR = 'GDPR',
  /** Gravity Project Social Determinants of Health */
  GRAVITY_SDOH = 'GRAVITY_SDOH',
  /** Halal Food Processing Standards */
  HALAL = 'HALAL',
  /** Health Insurance Portability and Accountability Act */
  HIPAA = 'HIPAA',
  /** Health Level Seven Fast Healthcare Interoperability Resources */
  HL7_FHIR = 'HL7-FHIR',
  /** HL7 FHIR Release 4 */
  HL7_FHIR_R4 = 'HL7-FHIR-R4',
  /** HL7 Version 2 Messaging Standard */
  HL7_V2 = 'HL7_V2',
  /** International Building Code 2021 */
  IBC_2021 = 'IBC_2021',
  /** ICD-10-CM Clinical Modification Diagnosis Codes */
  ICD10_CM = 'ICD10_CM',
  /** Internal Revenue Code */
  IRC = 'IRC',
  /** IRS Payroll Tax Requirements */
  IRS = 'IRS',
  /** ISMP High-Alert Medication Safety Standards */
  ISMP_HIGH_ALERT = 'ISMP_HIGH_ALERT',
  /** LeadingAge Person-Centered Care Standards */
  LEADINGAGE = 'LEADINGAGE',
  /** Logical Observation Identifiers Names and Codes */
  LOINC = 'LOINC',
  /** CMS Promoting Interoperability (Meaningful Use) */
  MEANINGFUL_USE = 'MEANINGFUL_USE',
  /** Minnesota Building Code — ALF */
  MN_1306 = 'MN_1306',
  /** Minnesota Assisted Living Facility Licensure */
  MN_144G = 'MN_144G',
  /** Minnesota 144G.72 Dementia Care */
  MN_144G72 = 'MN_144G72',
  /** Minnesota State Labor Law — Minimum Wage */
  MN_177 = 'MN_177',
  /** Minnesota Employment Practices */
  MN_181 = 'MN_181',
  /** Minnesota Human Services Licensing Act */
  MN_245A = 'MN_245A',
  /** Minnesota Background Studies */
  MN_245C = 'MN_245C',
  /** Minnesota HCBS Service Standards */
  MN_245D = 'MN_245D',
  /** Minnesota Medical Assistance */
  MN_256B = 'MN_256B',
  /** Minnesota Community First Services and Supports */
  MN_256B85 = 'MN_256B85',
  /** Minnesota Maltreatment of Minors Reporting */
  MN_260E = 'MN_260E',
  /** Minnesota Food Code */
  MN_4626 = 'MN_4626',
  /** Minnesota Vulnerable Adults Reporting Act */
  MN_626_557 = 'MN_626_557',
  /** Minnesota DHS 245D Licensing (alias) */
  MN_DHS_245D = 'MN_DHS_245D',
  /** Minnesota DHS CFSS Program */
  MN_DHS_CFSS = 'MN_DHS_CFSS',
  /** Minnesota Health Care Programs */
  MN_MHCP = 'MN_MHCP',
  /** NCPDP Pharmacy Claims Billing */
  NCPDP_BILLING = 'NCPDP_BILLING',
  /** NCPDP SCRIPT & CMS Part D Formulary Standards */
  NCPDP_FORMULARY = 'NCPDP_FORMULARY',
  /** NCPDP SCRIPT E-Prescribing Standard */
  NCPDP_SCRIPT = 'NCPDP_SCRIPT',
  /** National Drug Code */
  NDC = 'NDC',
  /** National Electrical Code 2023 */
  NEC_2023 = 'NEC_2023',
  /** NFPA 101 Life Safety Code */
  NFPA_101 = 'NFPA_101',
  /** National Provider Identifier */
  NPI = 'NPI',
  /** ONC Clinical Decision Support */
  ONC_CDS = 'ONC_CDS',
  /** Occupational Safety and Health Administration Standards */
  OSHA = 'OSHA',
  /** FDA Pharmacovigilance Standards */
  PHARMACOVIGILANCE = 'PHARMACOVIGILANCE',
  /** Personal Responsibility and Work Opportunity Reconciliation Act */
  PRWORA = 'PRWORA',
  /** Residential Provider Association of Minnesota */
  RPAMN = 'RPAMN',
  /** RxNav Drug Interaction and Terminology API */
  RXNAV = 'RXNAV',
  /** RxNorm Normalized Drug Names */
  RXNORM = 'RXNORM',
  /** SNOMED CT Systematized Nomenclature of Medicine */
  SNOMED_CT = 'SNOMED_CT',
  /** System and Organization Controls 2 */
  SOC2 = 'SOC2',
  /** Sarbanes-Oxley Act */
  SOX = 'SOX',
  /** FDA Structured Product Labeling */
  SPL_LABELING = 'SPL_LABELING',
  /** The Joint Commission National Patient Safety Goals */
  TJC_NPSG = 'TJC_NPSG',
  /** Uniform Billing Form 04 */
  UB04 = 'UB04',
  /** Unified Code for Units of Measure */
  UCUM = 'UCUM',
  /** United States Core Data for Interoperability */
  USCDI = 'USCDI',
  /** USDA Food Safety and Inspection Service */
  USDA_FSIS = 'USDA_FSIS',
  /** US Core FHIR Implementation Guide */
  US_CORE_FHIR = 'US_CORE_FHIR',
  /** X12 EDI Standards (alias) */
  X12 = 'X12',
}

export interface ComplianceFrameworkMeta {
  id: string;
  fullName: string;
  domain: string;
  enforcer: string;
  jurisdiction: string;
}

export const COMPLIANCE_FRAMEWORK_METADATA: Record<ComplianceFramework, ComplianceFrameworkMeta> = {
  [ComplianceFramework.ACA]: {
    id: 'ACA',
    fullName: 'Affordable Care Act Employer Mandate',
    domain: 'employment',
    enforcer: 'IRS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.ADA]: {
    id: 'ADA',
    fullName: 'Americans with Disabilities Act',
    domain: 'employment',
    enforcer: 'DOJ',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.ANSI_X12]: {
    id: 'ANSI_X12',
    fullName: 'ANSI Accredited Standards Committee X12',
    domain: 'edi',
    enforcer: 'ANSI',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CAP_CRITICAL_VALUES]: {
    id: 'CAP_CRITICAL_VALUES',
    fullName: 'CAP Laboratory Critical Value Standards',
    domain: 'healthcare',
    enforcer: 'CAP',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CCPA]: {
    id: 'CCPA',
    fullName: 'California Consumer Privacy Act',
    domain: 'data_protection',
    enforcer: 'CA_AG',
    jurisdiction: 'state:CA',
  },
  [ComplianceFramework.CCPA_GARNISHMENT]: {
    id: 'CCPA_GARNISHMENT',
    fullName: 'Consumer Credit Protection Act — Garnishment',
    domain: 'employment',
    enforcer: 'DOL',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CDC_CVX]: {
    id: 'CDC_CVX',
    fullName: 'CDC Vaccine Administered Codes',
    domain: 'healthcare',
    enforcer: 'CDC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CDC_IIS]: {
    id: 'CDC_IIS',
    fullName: 'CDC Immunization Information System Standards',
    domain: 'healthcare',
    enforcer: 'CDC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CDC_MVX]: {
    id: 'CDC_MVX',
    fullName: 'CDC Vaccine Manufacturer Codes',
    domain: 'healthcare',
    enforcer: 'CDC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CDC_OPIOID_GUIDELINE]: {
    id: 'CDC_OPIOID_GUIDELINE',
    fullName: 'CDC Clinical Practice Guideline for Prescribing Opioids',
    domain: 'healthcare',
    enforcer: 'CDC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CFR_PART2]: {
    id: 'CFR_PART2',
    fullName: '42 CFR Part 2 Substance Use Disorder Confidentiality',
    domain: 'healthcare',
    enforcer: 'SAMHSA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CLIA]: {
    id: 'CLIA',
    fullName: 'Clinical Laboratory Improvement Amendments',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CMS_1500]: {
    id: 'CMS_1500',
    fullName: 'CMS-1500 Health Insurance Claim Form',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CMS_CMS9115]: {
    id: 'CMS_CMS9115',
    fullName: 'CMS Interoperability & Prior Authorization Final Rule',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CMS_COP]: {
    id: 'CMS_COP',
    fullName: 'CMS Conditions of Participation',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CMS_HCBS_SETTINGS]: {
    id: 'CMS_HCBS_SETTINGS',
    fullName: 'CMS HCBS Settings Rule',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CMS_HEDIS_MIPS]: {
    id: 'CMS_HEDIS_MIPS',
    fullName: 'CMS HEDIS & MIPS Quality Reporting Measures',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CMS_PART_D]: {
    id: 'CMS_PART_D',
    fullName: 'CMS Medicare Part D Prescription Drug Benefit',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CMS_STAR_RATINGS]: {
    id: 'CMS_STAR_RATINGS',
    fullName: 'CMS Medicare Star Ratings Program',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.COBRA]: {
    id: 'COBRA',
    fullName: 'Consolidated Omnibus Budget Reconciliation Act',
    domain: 'employment',
    enforcer: 'DOL',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.CPMN]: {
    id: 'CPMN',
    fullName: 'Care Providers of Minnesota Standards',
    domain: 'healthcare',
    enforcer: 'CPMN',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.DAVIS_BACON]: {
    id: 'DAVIS_BACON',
    fullName: 'Davis-Bacon and Related Acts',
    domain: 'employment',
    enforcer: 'DOL',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.DEA_CONTROLLED_SUBSTANCES]: {
    id: 'DEA_CONTROLLED_SUBSTANCES',
    fullName: 'DEA Controlled Substances Act',
    domain: 'healthcare',
    enforcer: 'DEA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.DEA_NUMBER]: {
    id: 'DEA_NUMBER',
    fullName: 'DEA Registration Number',
    domain: 'healthcare',
    enforcer: 'DEA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.EEOC]: {
    id: 'EEOC',
    fullName: 'Equal Employment Opportunity Commission Requirements',
    domain: 'employment',
    enforcer: 'EEOC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.EPCS]: {
    id: 'EPCS',
    fullName: 'Electronic Prescribing of Controlled Substances',
    domain: 'healthcare',
    enforcer: 'DEA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.ERISA]: {
    id: 'ERISA',
    fullName: 'Employee Retirement Income Security Act',
    domain: 'employment',
    enforcer: 'DOL',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.FDA_21_CFR_Part_11]: {
    id: 'FDA_21_CFR_Part_11',
    fullName: 'FDA 21 CFR Part 11 - Electronic Records',
    domain: 'healthcare',
    enforcer: 'FDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.FDA_DRUG_LABELING]: {
    id: 'FDA_DRUG_LABELING',
    fullName: 'FDA DailyMed Drug Labeling',
    domain: 'healthcare',
    enforcer: 'FDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.FDA_DRUG_LISTING]: {
    id: 'FDA_DRUG_LISTING',
    fullName: 'FDA Drug Establishment Registration and Listing',
    domain: 'healthcare',
    enforcer: 'FDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.FDA_DRUG_SAFETY]: {
    id: 'FDA_DRUG_SAFETY',
    fullName: 'FDA Drug Safety & REMS Program Requirements',
    domain: 'healthcare',
    enforcer: 'FDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.FDA_FAERS]: {
    id: 'FDA_FAERS',
    fullName: 'FDA Adverse Event Reporting System',
    domain: 'healthcare',
    enforcer: 'FDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.FDA_REMS]: {
    id: 'FDA_REMS',
    fullName: 'FDA Risk Evaluation and Mitigation Strategies',
    domain: 'healthcare',
    enforcer: 'FDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.FDA_UNII]: {
    id: 'FDA_UNII',
    fullName: 'FDA Unique Ingredient Identifier',
    domain: 'healthcare',
    enforcer: 'FDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.FERP_INTERNAL]: {
    id: 'FERP_INTERNAL',
    fullName: 'FERP Internal Compliance Standards',
    domain: 'operations',
    enforcer: 'FERP',
    jurisdiction: 'internal',
  },
  [ComplianceFramework.FHIR_R4]: {
    id: 'FHIR_R4',
    fullName: 'FHIR Release 4 (alias)',
    domain: 'healthcare',
    enforcer: 'HL7_International',
    jurisdiction: 'international',
  },
  [ComplianceFramework.FLSA]: {
    id: 'FLSA',
    fullName: 'Fair Labor Standards Act',
    domain: 'employment',
    enforcer: 'DOL',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.FMLA]: {
    id: 'FMLA',
    fullName: 'Family and Medical Leave Act',
    domain: 'employment',
    enforcer: 'DOL',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.GAAP]: {
    id: 'GAAP',
    fullName: 'Generally Accepted Accounting Principles',
    domain: 'financial',
    enforcer: 'FASB',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.GDPR]: {
    id: 'GDPR',
    fullName: 'General Data Protection Regulation',
    domain: 'data_protection',
    enforcer: 'EU_DPAs',
    jurisdiction: 'international',
  },
  [ComplianceFramework.GRAVITY_SDOH]: {
    id: 'GRAVITY_SDOH',
    fullName: 'Gravity Project Social Determinants of Health',
    domain: 'healthcare',
    enforcer: 'HL7',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.HALAL]: {
    id: 'HALAL',
    fullName: 'Halal Food Processing Standards',
    domain: 'food_safety',
    enforcer: 'IFANCA',
    jurisdiction: 'international',
  },
  [ComplianceFramework.HIPAA]: {
    id: 'HIPAA',
    fullName: 'Health Insurance Portability and Accountability Act',
    domain: 'healthcare',
    enforcer: 'HHS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.HL7_FHIR]: {
    id: 'HL7-FHIR',
    fullName: 'Health Level Seven Fast Healthcare Interoperability Resources',
    domain: 'healthcare',
    enforcer: 'HL7_International',
    jurisdiction: 'international',
  },
  [ComplianceFramework.HL7_FHIR_R4]: {
    id: 'HL7-FHIR-R4',
    fullName: 'HL7 FHIR Release 4',
    domain: 'healthcare',
    enforcer: 'HL7_International',
    jurisdiction: 'international',
  },
  [ComplianceFramework.HL7_V2]: {
    id: 'HL7_V2',
    fullName: 'HL7 Version 2 Messaging Standard',
    domain: 'healthcare',
    enforcer: 'HL7',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.IBC_2021]: {
    id: 'IBC_2021',
    fullName: 'International Building Code 2021',
    domain: 'construction',
    enforcer: 'ICC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.ICD10_CM]: {
    id: 'ICD10_CM',
    fullName: 'ICD-10-CM Clinical Modification Diagnosis Codes',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.IRC]: {
    id: 'IRC',
    fullName: 'Internal Revenue Code',
    domain: 'financial',
    enforcer: 'IRS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.IRS]: {
    id: 'IRS',
    fullName: 'IRS Payroll Tax Requirements',
    domain: 'financial',
    enforcer: 'IRS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.ISMP_HIGH_ALERT]: {
    id: 'ISMP_HIGH_ALERT',
    fullName: 'ISMP High-Alert Medication Safety Standards',
    domain: 'healthcare',
    enforcer: 'ISMP',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.LEADINGAGE]: {
    id: 'LEADINGAGE',
    fullName: 'LeadingAge Person-Centered Care Standards',
    domain: 'healthcare',
    enforcer: 'LeadingAge',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.LOINC]: {
    id: 'LOINC',
    fullName: 'Logical Observation Identifiers Names and Codes',
    domain: 'healthcare',
    enforcer: 'Regenstrief',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.MEANINGFUL_USE]: {
    id: 'MEANINGFUL_USE',
    fullName: 'CMS Promoting Interoperability (Meaningful Use)',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.MN_1306]: {
    id: 'MN_1306',
    fullName: 'Minnesota Building Code — ALF',
    domain: 'construction',
    enforcer: 'DLI',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_144G]: {
    id: 'MN_144G',
    fullName: 'Minnesota Assisted Living Facility Licensure',
    domain: 'healthcare',
    enforcer: 'MDH',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_144G72]: {
    id: 'MN_144G72',
    fullName: 'Minnesota 144G.72 Dementia Care',
    domain: 'healthcare',
    enforcer: 'MDH',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_177]: {
    id: 'MN_177',
    fullName: 'Minnesota State Labor Law — Minimum Wage',
    domain: 'employment',
    enforcer: 'MNDOLI',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_181]: {
    id: 'MN_181',
    fullName: 'Minnesota Employment Practices',
    domain: 'employment',
    enforcer: 'MNDOLI',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_245A]: {
    id: 'MN_245A',
    fullName: 'Minnesota Human Services Licensing Act',
    domain: 'healthcare',
    enforcer: 'DHS',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_245C]: {
    id: 'MN_245C',
    fullName: 'Minnesota Background Studies',
    domain: 'healthcare',
    enforcer: 'DHS',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_245D]: {
    id: 'MN_245D',
    fullName: 'Minnesota HCBS Service Standards',
    domain: 'healthcare',
    enforcer: 'DHS',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_256B]: {
    id: 'MN_256B',
    fullName: 'Minnesota Medical Assistance',
    domain: 'healthcare',
    enforcer: 'DHS',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_256B85]: {
    id: 'MN_256B85',
    fullName: 'Minnesota Community First Services and Supports',
    domain: 'healthcare',
    enforcer: 'DHS',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_260E]: {
    id: 'MN_260E',
    fullName: 'Minnesota Maltreatment of Minors Reporting',
    domain: 'healthcare',
    enforcer: 'DHS',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_4626]: {
    id: 'MN_4626',
    fullName: 'Minnesota Food Code',
    domain: 'food_safety',
    enforcer: 'MDH',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_626_557]: {
    id: 'MN_626_557',
    fullName: 'Minnesota Vulnerable Adults Reporting Act',
    domain: 'healthcare',
    enforcer: 'DHS',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_DHS_245D]: {
    id: 'MN_DHS_245D',
    fullName: 'Minnesota DHS 245D Licensing (alias)',
    domain: 'healthcare',
    enforcer: 'DHS',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_DHS_CFSS]: {
    id: 'MN_DHS_CFSS',
    fullName: 'Minnesota DHS CFSS Program',
    domain: 'healthcare',
    enforcer: 'DHS',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.MN_MHCP]: {
    id: 'MN_MHCP',
    fullName: 'Minnesota Health Care Programs',
    domain: 'healthcare',
    enforcer: 'DHS',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.NCPDP_BILLING]: {
    id: 'NCPDP_BILLING',
    fullName: 'NCPDP Pharmacy Claims Billing',
    domain: 'healthcare',
    enforcer: 'NCPDP',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.NCPDP_FORMULARY]: {
    id: 'NCPDP_FORMULARY',
    fullName: 'NCPDP SCRIPT & CMS Part D Formulary Standards',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.NCPDP_SCRIPT]: {
    id: 'NCPDP_SCRIPT',
    fullName: 'NCPDP SCRIPT E-Prescribing Standard',
    domain: 'healthcare',
    enforcer: 'NCPDP',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.NDC]: {
    id: 'NDC',
    fullName: 'National Drug Code',
    domain: 'healthcare',
    enforcer: 'FDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.NEC_2023]: {
    id: 'NEC_2023',
    fullName: 'National Electrical Code 2023',
    domain: 'construction',
    enforcer: 'NFPA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.NFPA_101]: {
    id: 'NFPA_101',
    fullName: 'NFPA 101 Life Safety Code',
    domain: 'construction',
    enforcer: 'NFPA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.NPI]: {
    id: 'NPI',
    fullName: 'National Provider Identifier',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.ONC_CDS]: {
    id: 'ONC_CDS',
    fullName: 'ONC Clinical Decision Support',
    domain: 'healthcare',
    enforcer: 'ONC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.OSHA]: {
    id: 'OSHA',
    fullName: 'Occupational Safety and Health Administration Standards',
    domain: 'employment',
    enforcer: 'OSHA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.PHARMACOVIGILANCE]: {
    id: 'PHARMACOVIGILANCE',
    fullName: 'FDA Pharmacovigilance Standards',
    domain: 'healthcare',
    enforcer: 'FDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.PRWORA]: {
    id: 'PRWORA',
    fullName: 'Personal Responsibility and Work Opportunity Reconciliation Act',
    domain: 'employment',
    enforcer: 'DOL',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.RPAMN]: {
    id: 'RPAMN',
    fullName: 'Residential Provider Association of Minnesota',
    domain: 'healthcare',
    enforcer: 'RPAMN',
    jurisdiction: 'state:MN',
  },
  [ComplianceFramework.RXNAV]: {
    id: 'RXNAV',
    fullName: 'RxNav Drug Interaction and Terminology API',
    domain: 'healthcare',
    enforcer: 'NLM',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.RXNORM]: {
    id: 'RXNORM',
    fullName: 'RxNorm Normalized Drug Names',
    domain: 'healthcare',
    enforcer: 'NLM',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.SNOMED_CT]: {
    id: 'SNOMED_CT',
    fullName: 'SNOMED CT Systematized Nomenclature of Medicine',
    domain: 'healthcare',
    enforcer: 'NLM',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.SOC2]: {
    id: 'SOC2',
    fullName: 'System and Organization Controls 2',
    domain: 'financial',
    enforcer: 'AICPA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.SOX]: {
    id: 'SOX',
    fullName: 'Sarbanes-Oxley Act',
    domain: 'financial',
    enforcer: 'SEC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.SPL_LABELING]: {
    id: 'SPL_LABELING',
    fullName: 'FDA Structured Product Labeling',
    domain: 'healthcare',
    enforcer: 'FDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.TJC_NPSG]: {
    id: 'TJC_NPSG',
    fullName: 'The Joint Commission National Patient Safety Goals',
    domain: 'healthcare',
    enforcer: 'TJC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.UB04]: {
    id: 'UB04',
    fullName: 'Uniform Billing Form 04',
    domain: 'healthcare',
    enforcer: 'CMS',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.UCUM]: {
    id: 'UCUM',
    fullName: 'Unified Code for Units of Measure',
    domain: 'healthcare',
    enforcer: 'Regenstrief',
    jurisdiction: 'international',
  },
  [ComplianceFramework.USCDI]: {
    id: 'USCDI',
    fullName: 'United States Core Data for Interoperability',
    domain: 'healthcare',
    enforcer: 'ONC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.USDA_FSIS]: {
    id: 'USDA_FSIS',
    fullName: 'USDA Food Safety and Inspection Service',
    domain: 'food_safety',
    enforcer: 'USDA',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.US_CORE_FHIR]: {
    id: 'US_CORE_FHIR',
    fullName: 'US Core FHIR Implementation Guide',
    domain: 'healthcare',
    enforcer: 'ONC',
    jurisdiction: 'federal',
  },
  [ComplianceFramework.X12]: {
    id: 'X12',
    fullName: 'X12 EDI Standards (alias)',
    domain: 'edi',
    enforcer: 'ANSI',
    jurisdiction: 'federal',
  },
};

// ══════════════════════════════════════════════════════════════════════════════
// EDGE TYPES
// ══════════════════════════════════════════════════════════════════════════════

export enum EdgeType {
  /** Task/config is required by a regulation or ruleset (Ring 1) */
  MANDATED_BY = 'MANDATED_BY',
  /** Config implements a regulatory requirement (Ring 1) */
  IMPLEMENTS = 'IMPLEMENTS',
  /** Entity is governed by a policy or authority (Ring 1) */
  GOVERNED_BY = 'GOVERNED_BY',
  /** Task improves a quality-of-life tag (tag:qol:*) (Ring 2) */
  IMPROVES = 'IMPROVES',
  /** Task mitigates a risk tag (tag:risk:*) (Ring 2) */
  MITIGATES = 'MITIGATES',
  /** Task links to a billing code for reimbursement (Ring 2) */
  REIMBURSES_VIA = 'REIMBURSES_VIA',
  /** Task requires a specific competency/training (Ring 3) */
  REQUIRES_COMPETENCY = 'REQUIRES_COMPETENCY',
  /** Config fulfills a requirement or goal (Ring 3) */
  FULFILLS = 'FULFILLS',
  /** Config depends on another config (DRR-166 cross-cutting) (Ring 3) */
  DEPENDS_ON = 'DEPENDS_ON',
  /** Form schema provides UI rendering for a workflow state (DRR-312) (Ring 3) */
  RENDERS = 'RENDERS',
  /** Workflow spawns another workflow instance (parent → child) (Ring 3) */
  SPAWNS = 'SPAWNS',
  /** Workflow was spawned by another workflow (child → parent) (Ring 3) */
  SPAWNED_BY = 'SPAWNED_BY',
  /** Workflow output feeds into another workflow's input (Ring 3) */
  FEEDS = 'FEEDS',
  /** Workflow receives input from another workflow's output (Ring 3) */
  FED_BY = 'FED_BY',
  /** Workflow produces a FHIR resource or primitive as output (Ring 3) */
  PRODUCES = 'PRODUCES',
  /** Resource was produced by a workflow (Ring 3) */
  PRODUCED_BY = 'PRODUCED_BY',
  /** Workflow completion unlocks another workflow to proceed (Ring 3) */
  GATES = 'GATES',
  /** Workflow is blocked until another workflow completes (Ring 3) */
  GATED_BY = 'GATED_BY',
  /** Compliance is evidenced by a document or record (Ring 4) */
  EVIDENCED_BY = 'EVIDENCED_BY',
  /** Supervisor relationship: plan coordinated by DON/lead (Ring 5) */
  COORDINATED_BY = 'COORDINATED_BY',
  /** Authority relationship: plan authorized by ALD/compliance (Ring 5) */
  AUTHORIZED_BY = 'AUTHORIZED_BY',
  /** Auditor relationship: entity reviewed by QA (Ring 5) */
  REVIEWED_BY = 'REVIEWED_BY',
  /** Caretaker → Subject: CNA serves resident (Ring 5) */
  SERVES = 'SERVES',
  /** Task → Performer: medication admin performed by med aide (Ring 5) */
  PERFORMED_BY = 'PERFORMED_BY',
  /** Assignment: task/role assigned to specific actor (Ring 5) */
  ASSIGNED_TO = 'ASSIGNED_TO',
  /** Direct supervision chain: actor supervised by supervisor (Ring 5) */
  SUPERVISED_BY = 'SUPERVISED_BY',
  /** Audit oversight: entity audited by QA reviewer (Ring 5) */
  AUDITED_BY = 'AUDITED_BY',
  /** Participant employs support worker (CFSS budget model) (Ring 5) */
  EMPLOYS = 'EMPLOYS',
  /** Worker employed by participant (CFSS budget model) (Ring 5) */
  EMPLOYED_BY = 'EMPLOYED_BY',
  /** Instance → Workflow config: running instance realizes a definition (Ring 6) */
  REALIZES = 'REALIZES',
  /** Inverse of REALIZES: config → all its running instances (Ring 6) */
  REALIZED_BY = 'REALIZED_BY',
  /** Task → Subject constellation: task serves this resident/patient (Ring 7) */
  SUBJECT_OF = 'SUBJECT_OF',
  /** Constellation → Tasks: all tasks for this subject (Ring 7) */
  HAS_SUBJECT = 'HAS_SUBJECT',
  /** Task → Encounter constellation: task billable under this authorization (Ring 7) */
  BILLABLE_VIA = 'BILLABLE_VIA',
  /** Encounter → Tasks: all tasks billable to this encounter (Ring 7) */
  BILLS_FOR = 'BILLS_FOR',
  /** Task → Facility constellation: task performed at this location (Ring 7) */
  LOCATED_AT = 'LOCATED_AT',
  /** Facility → Tasks: all tasks at this location (Ring 7) */
  LOCATION_OF = 'LOCATION_OF',
}

export interface EdgeTypeMeta {
  id: string;
  ring: number;
  category: string;
  inverse: string;
  description: string;
  requiresProvisionRefs: boolean;
}

export const EDGE_TYPE_METADATA: Record<EdgeType, EdgeTypeMeta> = {
  [EdgeType.MANDATED_BY]: {
    id: 'MANDATED_BY',
    ring: 1,
    category: 'regulatory',
    inverse: 'MANDATES',
    description: 'Task/config is required by a regulation or ruleset',
    requiresProvisionRefs: true,
  },
  [EdgeType.IMPLEMENTS]: {
    id: 'IMPLEMENTS',
    ring: 1,
    category: 'regulatory',
    inverse: 'IMPLEMENTED_BY',
    description: 'Config implements a regulatory requirement',
    requiresProvisionRefs: false,
  },
  [EdgeType.GOVERNED_BY]: {
    id: 'GOVERNED_BY',
    ring: 1,
    category: 'regulatory',
    inverse: 'GOVERNS',
    description: 'Entity is governed by a policy or authority',
    requiresProvisionRefs: false,
  },
  [EdgeType.IMPROVES]: {
    id: 'IMPROVES',
    ring: 2,
    category: 'outcomes',
    inverse: 'IMPROVED_BY',
    description: 'Task improves a quality-of-life tag (tag:qol:*)',
    requiresProvisionRefs: false,
  },
  [EdgeType.MITIGATES]: {
    id: 'MITIGATES',
    ring: 2,
    category: 'outcomes',
    inverse: 'MITIGATED_BY',
    description: 'Task mitigates a risk tag (tag:risk:*)',
    requiresProvisionRefs: false,
  },
  [EdgeType.REIMBURSES_VIA]: {
    id: 'REIMBURSES_VIA',
    ring: 2,
    category: 'outcomes',
    inverse: 'REIMBURSES',
    description: 'Task links to a billing code for reimbursement',
    requiresProvisionRefs: false,
  },
  [EdgeType.REQUIRES_COMPETENCY]: {
    id: 'REQUIRES_COMPETENCY',
    ring: 3,
    category: 'operations',
    inverse: 'QUALIFIES_FOR',
    description: 'Task requires a specific competency/training',
    requiresProvisionRefs: false,
  },
  [EdgeType.FULFILLS]: {
    id: 'FULFILLS',
    ring: 3,
    category: 'operations',
    inverse: 'FULFILLED_BY',
    description: 'Config fulfills a requirement or goal',
    requiresProvisionRefs: false,
  },
  [EdgeType.DEPENDS_ON]: {
    id: 'DEPENDS_ON',
    ring: 3,
    category: 'operations',
    inverse: 'DEPENDED_ON_BY',
    description: 'Config depends on another config (DRR-166 cross-cutting)',
    requiresProvisionRefs: false,
  },
  [EdgeType.RENDERS]: {
    id: 'RENDERS',
    ring: 3,
    category: 'operations',
    inverse: 'RENDERED_BY',
    description: 'Form schema provides UI rendering for a workflow state (DRR-312)',
    requiresProvisionRefs: false,
  },
  [EdgeType.SPAWNS]: {
    id: 'SPAWNS',
    ring: 3,
    category: 'workflow_orchestration',
    inverse: 'SPAWNED_BY',
    description: 'Workflow spawns another workflow instance (parent → child)',
    requiresProvisionRefs: false,
  },
  [EdgeType.SPAWNED_BY]: {
    id: 'SPAWNED_BY',
    ring: 3,
    category: 'workflow_orchestration',
    inverse: 'SPAWNS',
    description: 'Workflow was spawned by another workflow (child → parent)',
    requiresProvisionRefs: false,
  },
  [EdgeType.FEEDS]: {
    id: 'FEEDS',
    ring: 3,
    category: 'workflow_orchestration',
    inverse: 'FED_BY',
    description: 'Workflow output feeds into another workflow\'s input',
    requiresProvisionRefs: false,
  },
  [EdgeType.FED_BY]: {
    id: 'FED_BY',
    ring: 3,
    category: 'workflow_orchestration',
    inverse: 'FEEDS',
    description: 'Workflow receives input from another workflow\'s output',
    requiresProvisionRefs: false,
  },
  [EdgeType.PRODUCES]: {
    id: 'PRODUCES',
    ring: 3,
    category: 'workflow_orchestration',
    inverse: 'PRODUCED_BY',
    description: 'Workflow produces a FHIR resource or primitive as output',
    requiresProvisionRefs: false,
  },
  [EdgeType.PRODUCED_BY]: {
    id: 'PRODUCED_BY',
    ring: 3,
    category: 'workflow_orchestration',
    inverse: 'PRODUCES',
    description: 'Resource was produced by a workflow',
    requiresProvisionRefs: false,
  },
  [EdgeType.GATES]: {
    id: 'GATES',
    ring: 3,
    category: 'workflow_orchestration',
    inverse: 'GATED_BY',
    description: 'Workflow completion unlocks another workflow to proceed',
    requiresProvisionRefs: false,
  },
  [EdgeType.GATED_BY]: {
    id: 'GATED_BY',
    ring: 3,
    category: 'workflow_orchestration',
    inverse: 'GATES',
    description: 'Workflow is blocked until another workflow completes',
    requiresProvisionRefs: false,
  },
  [EdgeType.EVIDENCED_BY]: {
    id: 'EVIDENCED_BY',
    ring: 4,
    category: 'evidence',
    inverse: 'EVIDENCES',
    description: 'Compliance is evidenced by a document or record',
    requiresProvisionRefs: false,
  },
  [EdgeType.COORDINATED_BY]: {
    id: 'COORDINATED_BY',
    ring: 5,
    category: 'participants',
    inverse: 'COORDINATES',
    description: 'Supervisor relationship: plan coordinated by DON/lead',
    requiresProvisionRefs: false,
  },
  [EdgeType.AUTHORIZED_BY]: {
    id: 'AUTHORIZED_BY',
    ring: 5,
    category: 'participants',
    inverse: 'AUTHORIZES',
    description: 'Authority relationship: plan authorized by ALD/compliance',
    requiresProvisionRefs: false,
  },
  [EdgeType.REVIEWED_BY]: {
    id: 'REVIEWED_BY',
    ring: 5,
    category: 'participants',
    inverse: 'REVIEWS',
    description: 'Auditor relationship: entity reviewed by QA',
    requiresProvisionRefs: false,
  },
  [EdgeType.SERVES]: {
    id: 'SERVES',
    ring: 5,
    category: 'participants',
    inverse: 'SERVED_BY',
    description: 'Caretaker → Subject: CNA serves resident',
    requiresProvisionRefs: false,
  },
  [EdgeType.PERFORMED_BY]: {
    id: 'PERFORMED_BY',
    ring: 5,
    category: 'participants',
    inverse: 'PERFORMS',
    description: 'Task → Performer: medication admin performed by med aide',
    requiresProvisionRefs: false,
  },
  [EdgeType.ASSIGNED_TO]: {
    id: 'ASSIGNED_TO',
    ring: 5,
    category: 'participants',
    inverse: 'ASSIGNED_FROM',
    description: 'Assignment: task/role assigned to specific actor',
    requiresProvisionRefs: false,
  },
  [EdgeType.SUPERVISED_BY]: {
    id: 'SUPERVISED_BY',
    ring: 5,
    category: 'participants',
    inverse: 'SUPERVISES',
    description: 'Direct supervision chain: actor supervised by supervisor',
    requiresProvisionRefs: false,
  },
  [EdgeType.AUDITED_BY]: {
    id: 'AUDITED_BY',
    ring: 5,
    category: 'participants',
    inverse: 'AUDITS',
    description: 'Audit oversight: entity audited by QA reviewer',
    requiresProvisionRefs: false,
  },
  [EdgeType.EMPLOYS]: {
    id: 'EMPLOYS',
    ring: 5,
    category: 'participants',
    inverse: 'EMPLOYED_BY',
    description: 'Participant employs support worker (CFSS budget model)',
    requiresProvisionRefs: false,
  },
  [EdgeType.EMPLOYED_BY]: {
    id: 'EMPLOYED_BY',
    ring: 5,
    category: 'participants',
    inverse: 'EMPLOYS',
    description: 'Worker employed by participant (CFSS budget model)',
    requiresProvisionRefs: false,
  },
  [EdgeType.REALIZES]: {
    id: 'REALIZES',
    ring: 6,
    category: 'instance_config',
    inverse: 'REALIZED_BY',
    description: 'Instance → Workflow config: running instance realizes a definition',
    requiresProvisionRefs: false,
  },
  [EdgeType.REALIZED_BY]: {
    id: 'REALIZED_BY',
    ring: 6,
    category: 'instance_config',
    inverse: 'REALIZES',
    description: 'Inverse of REALIZES: config → all its running instances',
    requiresProvisionRefs: false,
  },
  [EdgeType.SUBJECT_OF]: {
    id: 'SUBJECT_OF',
    ring: 7,
    category: 'instance_constellation',
    inverse: 'HAS_SUBJECT',
    description: 'Task → Subject constellation: task serves this resident/patient',
    requiresProvisionRefs: false,
  },
  [EdgeType.HAS_SUBJECT]: {
    id: 'HAS_SUBJECT',
    ring: 7,
    category: 'instance_constellation',
    inverse: 'SUBJECT_OF',
    description: 'Constellation → Tasks: all tasks for this subject',
    requiresProvisionRefs: false,
  },
  [EdgeType.BILLABLE_VIA]: {
    id: 'BILLABLE_VIA',
    ring: 7,
    category: 'instance_constellation',
    inverse: 'BILLS_FOR',
    description: 'Task → Encounter constellation: task billable under this authorization',
    requiresProvisionRefs: false,
  },
  [EdgeType.BILLS_FOR]: {
    id: 'BILLS_FOR',
    ring: 7,
    category: 'instance_constellation',
    inverse: 'BILLABLE_VIA',
    description: 'Encounter → Tasks: all tasks billable to this encounter',
    requiresProvisionRefs: false,
  },
  [EdgeType.LOCATED_AT]: {
    id: 'LOCATED_AT',
    ring: 7,
    category: 'instance_constellation',
    inverse: 'LOCATION_OF',
    description: 'Task → Facility constellation: task performed at this location',
    requiresProvisionRefs: false,
  },
  [EdgeType.LOCATION_OF]: {
    id: 'LOCATION_OF',
    ring: 7,
    category: 'instance_constellation',
    inverse: 'LOCATED_AT',
    description: 'Facility → Tasks: all tasks at this location',
    requiresProvisionRefs: false,
  },
};

// ══════════════════════════════════════════════════════════════════════════════
// FORM FIELD TYPES
// ══════════════════════════════════════════════════════════════════════════════

export enum FormFieldType {
  /** Single-line text input */
  String = 'string',
  /** Single-line text input (alias for string) */
  Text = 'text',
  /** Multi-line text input */
  Textarea = 'textarea',
  /** Email address input with validation */
  Email = 'email',
  /** Phone number input with formatting */
  Phone = 'phone',
  /** URL input with validation */
  Url = 'url',
  /** Rich text editor with formatting */
  Richtext = 'richtext',
  /** Markdown text editor */
  Markdown = 'markdown',
  /** Code editor with syntax highlighting */
  Code = 'code',
  /** Single-selection dropdown */
  Select = 'select',
  /** Multi-selection dropdown */
  Multiselect = 'multiselect',
  /** Radio button group */
  Radio = 'radio',
  /** Single checkbox */
  Checkbox = 'checkbox',
  /** Toggle switch */
  Toggle = 'toggle',
  /** Boolean toggle (alias for toggle) */
  Boolean = 'boolean',
  /** Generic number input */
  Number = 'number',
  /** Integer number input */
  Integer = 'integer',
  /** Decimal number input */
  Decimal = 'decimal',
  /** Currency input with formatting */
  Currency = 'currency',
  /** Percentage input (0-100) */
  Percentage = 'percentage',
  /** Date picker */
  Date = 'date',
  /** Time input */
  Time = 'time',
  /** Date and time picker */
  Datetime = 'datetime',
  /** Reference to another entity */
  Reference = 'reference',
  /** Actor selection with role/team filtering */
  Actorselect = 'actorselect',
  /** Digital signature capture */
  Signature = 'signature',
  /** Read-only display field */
  Readonly = 'readonly',
  /** File upload field */
  File = 'file',
  /** JSON object editor */
  Json = 'json',
}

export interface FormFieldTypeMeta {
  id: string;
  renderer: string;
  validators: string[];
  description: string;
}

export const FORM_FIELD_TYPE_METADATA: Record<FormFieldType, FormFieldTypeMeta> = {
  [FormFieldType.String]: {
    id: 'string',
    renderer: 'TextInput',
    validators: ['required', 'minLength', 'maxLength', 'pattern'],
    description: 'Single-line text input',
  },
  [FormFieldType.Text]: {
    id: 'text',
    renderer: 'TextInput',
    validators: ['required', 'minLength', 'maxLength', 'pattern'],
    description: 'Single-line text input (alias for string)',
  },
  [FormFieldType.Textarea]: {
    id: 'textarea',
    renderer: 'Textarea',
    validators: ['required', 'minLength', 'maxLength'],
    description: 'Multi-line text input',
  },
  [FormFieldType.Email]: {
    id: 'email',
    renderer: 'TextInput',
    validators: ['required', 'email'],
    description: 'Email address input with validation',
  },
  [FormFieldType.Phone]: {
    id: 'phone',
    renderer: 'TextInput',
    validators: ['required', 'phone'],
    description: 'Phone number input with formatting',
  },
  [FormFieldType.Url]: {
    id: 'url',
    renderer: 'TextInput',
    validators: ['required', 'url'],
    description: 'URL input with validation',
  },
  [FormFieldType.Richtext]: {
    id: 'richtext',
    renderer: 'RichTextEditor',
    validators: ['required', 'maxLength'],
    description: 'Rich text editor with formatting',
  },
  [FormFieldType.Markdown]: {
    id: 'markdown',
    renderer: 'MarkdownEditor',
    validators: ['required', 'maxLength'],
    description: 'Markdown text editor',
  },
  [FormFieldType.Code]: {
    id: 'code',
    renderer: 'CodeEditor',
    validators: ['required'],
    description: 'Code editor with syntax highlighting',
  },
  [FormFieldType.Select]: {
    id: 'select',
    renderer: 'Select',
    validators: ['required', 'allowedValues'],
    description: 'Single-selection dropdown',
  },
  [FormFieldType.Multiselect]: {
    id: 'multiselect',
    renderer: 'MultiSelect',
    validators: ['required', 'minItems', 'maxItems'],
    description: 'Multi-selection dropdown',
  },
  [FormFieldType.Radio]: {
    id: 'radio',
    renderer: 'RadioGroup',
    validators: ['required'],
    description: 'Radio button group',
  },
  [FormFieldType.Checkbox]: {
    id: 'checkbox',
    renderer: 'Checkbox',
    validators: ['required'],
    description: 'Single checkbox',
  },
  [FormFieldType.Toggle]: {
    id: 'toggle',
    renderer: 'Switch',
    validators: ['required'],
    description: 'Toggle switch',
  },
  [FormFieldType.Boolean]: {
    id: 'boolean',
    renderer: 'Switch',
    validators: ['required'],
    description: 'Boolean toggle (alias for toggle)',
  },
  [FormFieldType.Number]: {
    id: 'number',
    renderer: 'NumberInput',
    validators: ['required', 'min', 'max'],
    description: 'Generic number input',
  },
  [FormFieldType.Integer]: {
    id: 'integer',
    renderer: 'NumberInput',
    validators: ['required', 'min', 'max'],
    description: 'Integer number input',
  },
  [FormFieldType.Decimal]: {
    id: 'decimal',
    renderer: 'NumberInput',
    validators: ['required', 'min', 'max', 'precision'],
    description: 'Decimal number input',
  },
  [FormFieldType.Currency]: {
    id: 'currency',
    renderer: 'CurrencyInput',
    validators: ['required', 'min', 'max'],
    description: 'Currency input with formatting',
  },
  [FormFieldType.Percentage]: {
    id: 'percentage',
    renderer: 'NumberInput',
    validators: ['required', 'min', 'max'],
    description: 'Percentage input (0-100)',
  },
  [FormFieldType.Date]: {
    id: 'date',
    renderer: 'DatePicker',
    validators: ['required', 'minDate', 'maxDate'],
    description: 'Date picker',
  },
  [FormFieldType.Time]: {
    id: 'time',
    renderer: 'TimeInput',
    validators: ['required'],
    description: 'Time input',
  },
  [FormFieldType.Datetime]: {
    id: 'datetime',
    renderer: 'DateTimePicker',
    validators: ['required', 'minDate', 'maxDate'],
    description: 'Date and time picker',
  },
  [FormFieldType.Reference]: {
    id: 'reference',
    renderer: 'EntityReference',
    validators: ['required'],
    description: 'Reference to another entity',
  },
  [FormFieldType.Actorselect]: {
    id: 'actorselect',
    renderer: 'ActorSelect',
    validators: ['required'],
    description: 'Actor selection with role/team filtering',
  },
  [FormFieldType.Signature]: {
    id: 'signature',
    renderer: 'SignaturePad',
    validators: ['required'],
    description: 'Digital signature capture',
  },
  [FormFieldType.Readonly]: {
    id: 'readonly',
    renderer: 'ReadonlyField',
    validators: [],
    description: 'Read-only display field',
  },
  [FormFieldType.File]: {
    id: 'file',
    renderer: 'FileUpload',
    validators: ['required', 'maxSize', 'accept'],
    description: 'File upload field',
  },
  [FormFieldType.Json]: {
    id: 'json',
    renderer: 'JsonEditor',
    validators: ['required', 'jsonSchema'],
    description: 'JSON object editor',
  },
};

// ══════════════════════════════════════════════════════════════════════════════
// EVENT TYPES
// ══════════════════════════════════════════════════════════════════════════════

export enum EventType {
  /** Workflow instance created and started (T1) */
  WorkflowStarted = 'workflow_started',
  /** Workflow entered a new state (T2) */
  WorkflowStateEntered = 'workflow_state_entered',
  /** Workflow exited a state (T2) */
  WorkflowStateExited = 'workflow_state_exited',
  /** Workflow transition was fired (T2) */
  WorkflowTransitionFired = 'workflow_transition_fired',
  /** Workflow instance completed successfully (T1) */
  WorkflowCompleted = 'workflow_completed',
  /** Workflow instance failed (T1) */
  WorkflowFailed = 'workflow_failed',
  /** Workflow instance paused (T2) */
  WorkflowPaused = 'workflow_paused',
  /** Workflow instance resumed (T2) */
  WorkflowResumed = 'workflow_resumed',
  /** Workflow heartbeat for self-scheduling (DRR-127) (T4) */
  WorkflowHeartbeat = 'workflow_heartbeat',
  /** Task was created (T1) */
  TaskCreated = 'task_created',
  /** Task was assigned to an actor (T2) */
  TaskAssigned = 'task_assigned',
  /** Task work was started (T2) */
  TaskStarted = 'task_started',
  /** Task was completed (T1) */
  TaskCompleted = 'task_completed',
  /** Task failed (T1) */
  TaskFailed = 'task_failed',
  /** Task was escalated (SLA violation) (T1) */
  TaskEscalated = 'task_escalated',
  /** Task was reassigned to different actor (T2) */
  TaskReassigned = 'task_reassigned',
  /** Task progress percentage updated (T3) */
  TaskProgressUpdated = 'task_progress_updated',
  /** Actor was created (T1) */
  ActorCreated = 'actor_created',
  /** Actor profile was updated (T2) */
  ActorUpdated = 'actor_updated',
  /** Role was assigned to actor (T1) */
  ActorRoleAssigned = 'actor_role_assigned',
  /** Role was revoked from actor (T1) */
  ActorRoleRevoked = 'actor_role_revoked',
  /** Actor logged in (T2) */
  ActorLogin = 'actor_login',
  /** Actor logged out (T2) */
  ActorLogout = 'actor_logout',
  /** Actor session expired (T2) */
  ActorSessionExpired = 'actor_session_expired',
  /** Document was created (T1) */
  DocumentCreated = 'document_created',
  /** Document was signed (T1) */
  DocumentSigned = 'document_signed',
  /** Document was viewed (T2) */
  DocumentViewed = 'document_viewed',
  /** Document was downloaded (T2) */
  DocumentDownloaded = 'document_downloaded',
  /** Document was shared (T2) */
  DocumentShared = 'document_shared',
  /** Document access was revoked (T1) */
  DocumentRevoked = 'document_revoked',
  /** PDF document was generated (T2) */
  PdfGenerated = 'pdf_generated',
  /** PDF generated in offline mode (DRR-133) (T1) */
  PdfGeneratedOffline = 'pdf_generated_offline',
  /** Policy was evaluated by Zen Engine (T2) */
  PolicyEvaluated = 'policy_evaluated',
  /** Policy violation detected (T1) */
  PolicyViolation = 'policy_violation',
  /** Compliance check passed (T2) */
  ComplianceCheckPassed = 'compliance_check_passed',
  /** Compliance check failed (T1) */
  ComplianceCheckFailed = 'compliance_check_failed',
  /** Audit trail entry created (T1) */
  AuditTrailEntry = 'audit_trail_entry',
  /** Regulation was applied to entity (T2) */
  RegulationApplied = 'regulation_applied',
  /** Care was delivered (attestation) (T1) */
  CareDelivered = 'care_delivered',
  /** Medication was administered (T1) */
  MedicationAdministered = 'medication_administered',
  /** Clinical assessment completed (T1) */
  AssessmentCompleted = 'assessment_completed',
  /** Care plan was updated (T1) */
  CarePlanUpdated = 'care_plan_updated',
  /** Clinical incident reported (T1) */
  IncidentReported = 'incident_reported',
  /** Vital signs recorded (raw sensor data) (T4) */
  VitalsRecorded = 'vitals_recorded',
  /** Configuration was changed (T1) */
  ConfigChanged = 'config_changed',
  /** Seed operation completed (T2) */
  SeedCompleted = 'seed_completed',
  /** Cache was invalidated (T4) */
  CacheInvalidated = 'cache_invalidated',
  /** Outbox message was processed (T4) */
  OutboxProcessed = 'outbox_processed',
  /** System error occurred (T2) */
  ErrorOccurred = 'error_occurred',
  /** External integration connected (T2) */
  IntegrationConnected = 'integration_connected',
  /** External integration disconnected (T2) */
  IntegrationDisconnected = 'integration_disconnected',
  /** Integration sync started (T2) */
  IntegrationSyncStarted = 'integration_sync_started',
  /** Integration sync completed (T2) */
  IntegrationSyncCompleted = 'integration_sync_completed',
  /** Integration sync failed (T1) */
  IntegrationSyncFailed = 'integration_sync_failed',
  /** Webhook was received (T3) */
  WebhookReceived = 'webhook_received',
  /** EDI transaction was transmitted (T1) */
  EdiTransmitted = 'edi_transmitted',
  /** EDI transaction was received (T1) */
  EdiReceived = 'edi_received',
}

export interface EventTypeMeta {
  id: string;
  category: string;
  tier: "T1" | "T2" | "T3" | "T4";
  schemaRef: string;
  audited: boolean;
  description: string;
  wall?: string;
}

export const EVENT_TYPE_METADATA: Record<EventType, EventTypeMeta> = {
  [EventType.WorkflowStarted]: {
    id: 'workflow_started',
    category: 'workflow',
    tier: 'T1',
    schemaRef: 'schema-event-workflow-lifecycle',
    audited: true,
    description: 'Workflow instance created and started',
  },
  [EventType.WorkflowStateEntered]: {
    id: 'workflow_state_entered',
    category: 'workflow',
    tier: 'T2',
    schemaRef: 'schema-event-workflow-state',
    audited: true,
    description: 'Workflow entered a new state',
  },
  [EventType.WorkflowStateExited]: {
    id: 'workflow_state_exited',
    category: 'workflow',
    tier: 'T2',
    schemaRef: 'schema-event-workflow-state',
    audited: true,
    description: 'Workflow exited a state',
  },
  [EventType.WorkflowTransitionFired]: {
    id: 'workflow_transition_fired',
    category: 'workflow',
    tier: 'T2',
    schemaRef: 'schema-event-workflow-transition',
    audited: true,
    description: 'Workflow transition was fired',
  },
  [EventType.WorkflowCompleted]: {
    id: 'workflow_completed',
    category: 'workflow',
    tier: 'T1',
    schemaRef: 'schema-event-workflow-lifecycle',
    audited: true,
    description: 'Workflow instance completed successfully',
  },
  [EventType.WorkflowFailed]: {
    id: 'workflow_failed',
    category: 'workflow',
    tier: 'T1',
    schemaRef: 'schema-event-workflow-error',
    audited: true,
    description: 'Workflow instance failed',
  },
  [EventType.WorkflowPaused]: {
    id: 'workflow_paused',
    category: 'workflow',
    tier: 'T2',
    schemaRef: 'schema-event-workflow-lifecycle',
    audited: true,
    description: 'Workflow instance paused',
  },
  [EventType.WorkflowResumed]: {
    id: 'workflow_resumed',
    category: 'workflow',
    tier: 'T2',
    schemaRef: 'schema-event-workflow-lifecycle',
    audited: true,
    description: 'Workflow instance resumed',
  },
  [EventType.WorkflowHeartbeat]: {
    id: 'workflow_heartbeat',
    category: 'workflow',
    tier: 'T4',
    schemaRef: 'schema-event-workflow-heartbeat',
    audited: false,
    description: 'Workflow heartbeat for self-scheduling (DRR-127)',
  },
  [EventType.TaskCreated]: {
    id: 'task_created',
    category: 'task',
    tier: 'T1',
    schemaRef: 'schema-event-task-lifecycle',
    audited: true,
    description: 'Task was created',
  },
  [EventType.TaskAssigned]: {
    id: 'task_assigned',
    category: 'task',
    tier: 'T2',
    schemaRef: 'schema-event-task-assignment',
    audited: true,
    description: 'Task was assigned to an actor',
  },
  [EventType.TaskStarted]: {
    id: 'task_started',
    category: 'task',
    tier: 'T2',
    schemaRef: 'schema-event-task-lifecycle',
    audited: true,
    description: 'Task work was started',
  },
  [EventType.TaskCompleted]: {
    id: 'task_completed',
    category: 'task',
    tier: 'T1',
    schemaRef: 'schema-event-task-lifecycle',
    audited: true,
    description: 'Task was completed',
  },
  [EventType.TaskFailed]: {
    id: 'task_failed',
    category: 'task',
    tier: 'T1',
    schemaRef: 'schema-event-task-error',
    audited: true,
    description: 'Task failed',
  },
  [EventType.TaskEscalated]: {
    id: 'task_escalated',
    category: 'task',
    tier: 'T1',
    schemaRef: 'schema-event-task-escalation',
    audited: true,
    description: 'Task was escalated (SLA violation)',
  },
  [EventType.TaskReassigned]: {
    id: 'task_reassigned',
    category: 'task',
    tier: 'T2',
    schemaRef: 'schema-event-task-assignment',
    audited: true,
    description: 'Task was reassigned to different actor',
  },
  [EventType.TaskProgressUpdated]: {
    id: 'task_progress_updated',
    category: 'task',
    tier: 'T3',
    schemaRef: 'schema-event-task-progress',
    audited: false,
    description: 'Task progress percentage updated',
  },
  [EventType.ActorCreated]: {
    id: 'actor_created',
    category: 'actor',
    tier: 'T1',
    schemaRef: 'schema-event-actor-lifecycle',
    audited: true,
    description: 'Actor was created',
  },
  [EventType.ActorUpdated]: {
    id: 'actor_updated',
    category: 'actor',
    tier: 'T2',
    schemaRef: 'schema-event-actor-update',
    audited: true,
    description: 'Actor profile was updated',
  },
  [EventType.ActorRoleAssigned]: {
    id: 'actor_role_assigned',
    category: 'actor',
    tier: 'T1',
    schemaRef: 'schema-event-actor-role',
    audited: true,
    description: 'Role was assigned to actor',
  },
  [EventType.ActorRoleRevoked]: {
    id: 'actor_role_revoked',
    category: 'actor',
    tier: 'T1',
    schemaRef: 'schema-event-actor-role',
    audited: true,
    description: 'Role was revoked from actor',
  },
  [EventType.ActorLogin]: {
    id: 'actor_login',
    category: 'actor',
    tier: 'T2',
    schemaRef: 'schema-event-actor-auth',
    audited: true,
    description: 'Actor logged in',
  },
  [EventType.ActorLogout]: {
    id: 'actor_logout',
    category: 'actor',
    tier: 'T2',
    schemaRef: 'schema-event-actor-auth',
    audited: true,
    description: 'Actor logged out',
  },
  [EventType.ActorSessionExpired]: {
    id: 'actor_session_expired',
    category: 'actor',
    tier: 'T2',
    schemaRef: 'schema-event-actor-auth',
    audited: false,
    description: 'Actor session expired',
  },
  [EventType.DocumentCreated]: {
    id: 'document_created',
    category: 'document',
    tier: 'T1',
    schemaRef: 'schema-event-document-lifecycle',
    audited: true,
    description: 'Document was created',
  },
  [EventType.DocumentSigned]: {
    id: 'document_signed',
    category: 'document',
    tier: 'T1',
    schemaRef: 'schema-event-document-signature',
    audited: true,
    description: 'Document was signed',
  },
  [EventType.DocumentViewed]: {
    id: 'document_viewed',
    category: 'document',
    tier: 'T2',
    schemaRef: 'schema-event-document-access',
    audited: true,
    description: 'Document was viewed',
  },
  [EventType.DocumentDownloaded]: {
    id: 'document_downloaded',
    category: 'document',
    tier: 'T2',
    schemaRef: 'schema-event-document-access',
    audited: true,
    description: 'Document was downloaded',
  },
  [EventType.DocumentShared]: {
    id: 'document_shared',
    category: 'document',
    tier: 'T2',
    schemaRef: 'schema-event-document-share',
    audited: true,
    description: 'Document was shared',
  },
  [EventType.DocumentRevoked]: {
    id: 'document_revoked',
    category: 'document',
    tier: 'T1',
    schemaRef: 'schema-event-document-lifecycle',
    audited: true,
    description: 'Document access was revoked',
  },
  [EventType.PdfGenerated]: {
    id: 'pdf_generated',
    category: 'document',
    tier: 'T2',
    schemaRef: 'schema-event-document-generation',
    audited: true,
    description: 'PDF document was generated',
  },
  [EventType.PdfGeneratedOffline]: {
    id: 'pdf_generated_offline',
    category: 'document',
    tier: 'T1',
    schemaRef: 'schema-event-document-generation',
    audited: true,
    description: 'PDF generated in offline mode (DRR-133)',
  },
  [EventType.PolicyEvaluated]: {
    id: 'policy_evaluated',
    category: 'compliance',
    tier: 'T2',
    schemaRef: 'schema-event-policy-evaluation',
    audited: true,
    description: 'Policy was evaluated by Zen Engine',
  },
  [EventType.PolicyViolation]: {
    id: 'policy_violation',
    category: 'compliance',
    tier: 'T1',
    schemaRef: 'schema-event-policy-violation',
    audited: true,
    description: 'Policy violation detected',
  },
  [EventType.ComplianceCheckPassed]: {
    id: 'compliance_check_passed',
    category: 'compliance',
    tier: 'T2',
    schemaRef: 'schema-event-compliance-check',
    audited: true,
    description: 'Compliance check passed',
  },
  [EventType.ComplianceCheckFailed]: {
    id: 'compliance_check_failed',
    category: 'compliance',
    tier: 'T1',
    schemaRef: 'schema-event-compliance-check',
    audited: true,
    description: 'Compliance check failed',
  },
  [EventType.AuditTrailEntry]: {
    id: 'audit_trail_entry',
    category: 'compliance',
    tier: 'T1',
    schemaRef: 'schema-event-audit-trail',
    audited: true,
    description: 'Audit trail entry created',
  },
  [EventType.RegulationApplied]: {
    id: 'regulation_applied',
    category: 'compliance',
    tier: 'T2',
    schemaRef: 'schema-event-regulation',
    audited: true,
    description: 'Regulation was applied to entity',
  },
  [EventType.CareDelivered]: {
    id: 'care_delivered',
    category: 'clinical',
    tier: 'T1',
    schemaRef: 'schema-event-care-delivery',
    audited: true,
    description: 'Care was delivered (attestation)',
    wall: 'clinical',
  },
  [EventType.MedicationAdministered]: {
    id: 'medication_administered',
    category: 'clinical',
    tier: 'T1',
    schemaRef: 'schema-event-medication',
    audited: true,
    description: 'Medication was administered',
    wall: 'clinical',
  },
  [EventType.AssessmentCompleted]: {
    id: 'assessment_completed',
    category: 'clinical',
    tier: 'T1',
    schemaRef: 'schema-event-assessment',
    audited: true,
    description: 'Clinical assessment completed',
    wall: 'clinical',
  },
  [EventType.CarePlanUpdated]: {
    id: 'care_plan_updated',
    category: 'clinical',
    tier: 'T1',
    schemaRef: 'schema-event-care-plan',
    audited: true,
    description: 'Care plan was updated',
    wall: 'clinical',
  },
  [EventType.IncidentReported]: {
    id: 'incident_reported',
    category: 'clinical',
    tier: 'T1',
    schemaRef: 'schema-event-incident',
    audited: true,
    description: 'Clinical incident reported',
    wall: 'clinical',
  },
  [EventType.VitalsRecorded]: {
    id: 'vitals_recorded',
    category: 'clinical',
    tier: 'T4',
    schemaRef: 'schema-event-vitals',
    audited: false,
    description: 'Vital signs recorded (raw sensor data)',
    wall: 'clinical',
  },
  [EventType.ConfigChanged]: {
    id: 'config_changed',
    category: 'system',
    tier: 'T1',
    schemaRef: 'schema-event-config-change',
    audited: true,
    description: 'Configuration was changed',
  },
  [EventType.SeedCompleted]: {
    id: 'seed_completed',
    category: 'system',
    tier: 'T2',
    schemaRef: 'schema-event-seed',
    audited: true,
    description: 'Seed operation completed',
  },
  [EventType.CacheInvalidated]: {
    id: 'cache_invalidated',
    category: 'system',
    tier: 'T4',
    schemaRef: 'schema-event-cache',
    audited: false,
    description: 'Cache was invalidated',
  },
  [EventType.OutboxProcessed]: {
    id: 'outbox_processed',
    category: 'system',
    tier: 'T4',
    schemaRef: 'schema-event-outbox',
    audited: false,
    description: 'Outbox message was processed',
  },
  [EventType.ErrorOccurred]: {
    id: 'error_occurred',
    category: 'system',
    tier: 'T2',
    schemaRef: 'schema-event-error',
    audited: true,
    description: 'System error occurred',
  },
  [EventType.IntegrationConnected]: {
    id: 'integration_connected',
    category: 'integration',
    tier: 'T2',
    schemaRef: 'schema-event-integration',
    audited: true,
    description: 'External integration connected',
  },
  [EventType.IntegrationDisconnected]: {
    id: 'integration_disconnected',
    category: 'integration',
    tier: 'T2',
    schemaRef: 'schema-event-integration',
    audited: true,
    description: 'External integration disconnected',
  },
  [EventType.IntegrationSyncStarted]: {
    id: 'integration_sync_started',
    category: 'integration',
    tier: 'T2',
    schemaRef: 'schema-event-integration-sync',
    audited: true,
    description: 'Integration sync started',
  },
  [EventType.IntegrationSyncCompleted]: {
    id: 'integration_sync_completed',
    category: 'integration',
    tier: 'T2',
    schemaRef: 'schema-event-integration-sync',
    audited: true,
    description: 'Integration sync completed',
  },
  [EventType.IntegrationSyncFailed]: {
    id: 'integration_sync_failed',
    category: 'integration',
    tier: 'T1',
    schemaRef: 'schema-event-integration-error',
    audited: true,
    description: 'Integration sync failed',
  },
  [EventType.WebhookReceived]: {
    id: 'webhook_received',
    category: 'integration',
    tier: 'T3',
    schemaRef: 'schema-event-webhook',
    audited: false,
    description: 'Webhook was received',
  },
  [EventType.EdiTransmitted]: {
    id: 'edi_transmitted',
    category: 'integration',
    tier: 'T1',
    schemaRef: 'schema-event-edi',
    audited: true,
    description: 'EDI transaction was transmitted',
  },
  [EventType.EdiReceived]: {
    id: 'edi_received',
    category: 'integration',
    tier: 'T1',
    schemaRef: 'schema-event-edi',
    audited: true,
    description: 'EDI transaction was received',
  },
};

export enum DataTier {
  T1 = "T1", // Attestation - indefinite retention
  T2 = "T2", // Operational - 1 year
  T3 = "T3", // QAPI - 90 days
  T4 = "T4", // Raw Sensor - 7-30 days auto-purge
}

export const DATA_TIER_TTL: Record<DataTier, number | null> = {
  [DataTier.T1]: null, // Indefinite
  [DataTier.T2]: 31536000, // 365 days
  [DataTier.T3]: 7776000, // 90 days
  [DataTier.T4]: 604800, // 7 days (configurable)
};

// ══════════════════════════════════════════════════════════════════════════════
// NOTIFICATION TYPES
// ══════════════════════════════════════════════════════════════════════════════

export enum NotificationType {
  /** Task has been assigned to user */
  TaskAssigned = 'task_assigned',
  /** Task is approaching due date */
  TaskDueSoon = 'task_due_soon',
  /** Task is past due date */
  TaskOverdue = 'task_overdue',
  /** Task has been completed */
  TaskCompleted = 'task_completed',
  /** Task has been reassigned */
  TaskReassigned = 'task_reassigned',
  /** Task has been escalated to supervisor */
  TaskEscalated = 'task_escalated',
  /** Workflow instance has started */
  WorkflowStarted = 'workflow_started',
  /** Workflow instance has completed */
  WorkflowCompleted = 'workflow_completed',
  /** Workflow instance has failed */
  WorkflowFailed = 'workflow_failed',
  /** Workflow is blocked and needs attention */
  WorkflowBlocked = 'workflow_blocked',
  /** Workflow has transitioned to a new state */
  WorkflowStateChanged = 'workflow_state_changed',
  /** Approval is required from user */
  ApprovalRequired = 'approval_required',
  /** Request has been approved */
  ApprovalApproved = 'approval_approved',
  /** Request has been rejected */
  ApprovalRejected = 'approval_rejected',
  /** Approval has been delegated to another user */
  ApprovalDelegated = 'approval_delegated',
  /** Approval request has been escalated */
  ApprovalEscalated = 'approval_escalated',
  /** Compliance violation detected */
  ComplianceViolation = 'compliance_violation',
  /** Compliance warning issued */
  ComplianceWarning = 'compliance_warning',
  /** Compliance deadline approaching */
  ComplianceDeadline = 'compliance_deadline',
  /** Compliance audit has been scheduled */
  ComplianceAuditScheduled = 'compliance_audit_scheduled',
  /** Regulatory requirement has been updated */
  RegulationUpdate = 'regulation_update',
  /** Scheduled system maintenance */
  SystemMaintenance = 'system_maintenance',
  /** Critical system alert */
  SystemAlert = 'system_alert',
  /** External integration error */
  IntegrationError = 'integration_error',
  /** User session is about to expire */
  SessionExpiring = 'session_expiring',
  /** Medication administration is due */
  MedicationDue = 'medication_due',
  /** Medication administration was missed */
  MedicationMissed = 'medication_missed',
  /** Resident care plan has been updated */
  CarePlanUpdated = 'care_plan_updated',
  /** Incident has been reported */
  IncidentReported = 'incident_reported',
  /** Assessment is due */
  AssessmentDue = 'assessment_due',
}

export type NotificationChannel = "email" | "push" | "in_app" | "sms";
export type NotificationPriority = "critical" | "urgent" | "high" | "normal" | "low";

export interface NotificationTypeMeta {
  id: string;
  category: string;
  channels: NotificationChannel[];
  priority: NotificationPriority;
  description: string;
  requiresAcknowledgment: boolean;
}

export const NOTIFICATION_TYPE_METADATA: Record<NotificationType, NotificationTypeMeta> = {
  [NotificationType.TaskAssigned]: {
    id: 'task_assigned',
    category: 'task',
    channels: ['in_app', 'email'],
    priority: 'normal',
    description: 'Task has been assigned to user',
    requiresAcknowledgment: false,
  },
  [NotificationType.TaskDueSoon]: {
    id: 'task_due_soon',
    category: 'task',
    channels: ['in_app', 'push'],
    priority: 'high',
    description: 'Task is approaching due date',
    requiresAcknowledgment: false,
  },
  [NotificationType.TaskOverdue]: {
    id: 'task_overdue',
    category: 'task',
    channels: ['in_app', 'push', 'email'],
    priority: 'urgent',
    description: 'Task is past due date',
    requiresAcknowledgment: true,
  },
  [NotificationType.TaskCompleted]: {
    id: 'task_completed',
    category: 'task',
    channels: ['in_app'],
    priority: 'low',
    description: 'Task has been completed',
    requiresAcknowledgment: false,
  },
  [NotificationType.TaskReassigned]: {
    id: 'task_reassigned',
    category: 'task',
    channels: ['in_app', 'email'],
    priority: 'normal',
    description: 'Task has been reassigned',
    requiresAcknowledgment: false,
  },
  [NotificationType.TaskEscalated]: {
    id: 'task_escalated',
    category: 'task',
    channels: ['in_app', 'push', 'email'],
    priority: 'high',
    description: 'Task has been escalated to supervisor',
    requiresAcknowledgment: true,
  },
  [NotificationType.WorkflowStarted]: {
    id: 'workflow_started',
    category: 'workflow',
    channels: ['in_app'],
    priority: 'normal',
    description: 'Workflow instance has started',
    requiresAcknowledgment: false,
  },
  [NotificationType.WorkflowCompleted]: {
    id: 'workflow_completed',
    category: 'workflow',
    channels: ['in_app', 'email'],
    priority: 'normal',
    description: 'Workflow instance has completed',
    requiresAcknowledgment: false,
  },
  [NotificationType.WorkflowFailed]: {
    id: 'workflow_failed',
    category: 'workflow',
    channels: ['in_app', 'push', 'email'],
    priority: 'urgent',
    description: 'Workflow instance has failed',
    requiresAcknowledgment: true,
  },
  [NotificationType.WorkflowBlocked]: {
    id: 'workflow_blocked',
    category: 'workflow',
    channels: ['in_app', 'email'],
    priority: 'high',
    description: 'Workflow is blocked and needs attention',
    requiresAcknowledgment: true,
  },
  [NotificationType.WorkflowStateChanged]: {
    id: 'workflow_state_changed',
    category: 'workflow',
    channels: ['in_app'],
    priority: 'low',
    description: 'Workflow has transitioned to a new state',
    requiresAcknowledgment: false,
  },
  [NotificationType.ApprovalRequired]: {
    id: 'approval_required',
    category: 'approval',
    channels: ['in_app', 'push', 'email'],
    priority: 'high',
    description: 'Approval is required from user',
    requiresAcknowledgment: false,
  },
  [NotificationType.ApprovalApproved]: {
    id: 'approval_approved',
    category: 'approval',
    channels: ['in_app', 'email'],
    priority: 'normal',
    description: 'Request has been approved',
    requiresAcknowledgment: false,
  },
  [NotificationType.ApprovalRejected]: {
    id: 'approval_rejected',
    category: 'approval',
    channels: ['in_app', 'email'],
    priority: 'high',
    description: 'Request has been rejected',
    requiresAcknowledgment: true,
  },
  [NotificationType.ApprovalDelegated]: {
    id: 'approval_delegated',
    category: 'approval',
    channels: ['in_app'],
    priority: 'normal',
    description: 'Approval has been delegated to another user',
    requiresAcknowledgment: false,
  },
  [NotificationType.ApprovalEscalated]: {
    id: 'approval_escalated',
    category: 'approval',
    channels: ['in_app', 'push'],
    priority: 'high',
    description: 'Approval request has been escalated',
    requiresAcknowledgment: true,
  },
  [NotificationType.ComplianceViolation]: {
    id: 'compliance_violation',
    category: 'compliance',
    channels: ['in_app', 'push', 'email'],
    priority: 'urgent',
    description: 'Compliance violation detected',
    requiresAcknowledgment: true,
  },
  [NotificationType.ComplianceWarning]: {
    id: 'compliance_warning',
    category: 'compliance',
    channels: ['in_app', 'email'],
    priority: 'high',
    description: 'Compliance warning issued',
    requiresAcknowledgment: false,
  },
  [NotificationType.ComplianceDeadline]: {
    id: 'compliance_deadline',
    category: 'compliance',
    channels: ['in_app', 'push', 'email'],
    priority: 'high',
    description: 'Compliance deadline approaching',
    requiresAcknowledgment: false,
  },
  [NotificationType.ComplianceAuditScheduled]: {
    id: 'compliance_audit_scheduled',
    category: 'compliance',
    channels: ['in_app', 'email'],
    priority: 'normal',
    description: 'Compliance audit has been scheduled',
    requiresAcknowledgment: true,
  },
  [NotificationType.RegulationUpdate]: {
    id: 'regulation_update',
    category: 'compliance',
    channels: ['in_app', 'email'],
    priority: 'normal',
    description: 'Regulatory requirement has been updated',
    requiresAcknowledgment: false,
  },
  [NotificationType.SystemMaintenance]: {
    id: 'system_maintenance',
    category: 'system',
    channels: ['in_app', 'email'],
    priority: 'normal',
    description: 'Scheduled system maintenance',
    requiresAcknowledgment: false,
  },
  [NotificationType.SystemAlert]: {
    id: 'system_alert',
    category: 'system',
    channels: ['in_app', 'push'],
    priority: 'urgent',
    description: 'Critical system alert',
    requiresAcknowledgment: true,
  },
  [NotificationType.IntegrationError]: {
    id: 'integration_error',
    category: 'system',
    channels: ['in_app', 'email'],
    priority: 'high',
    description: 'External integration error',
    requiresAcknowledgment: true,
  },
  [NotificationType.SessionExpiring]: {
    id: 'session_expiring',
    category: 'system',
    channels: ['in_app'],
    priority: 'normal',
    description: 'User session is about to expire',
    requiresAcknowledgment: false,
  },
  [NotificationType.MedicationDue]: {
    id: 'medication_due',
    category: 'clinical',
    channels: ['in_app', 'push'],
    priority: 'high',
    description: 'Medication administration is due',
    requiresAcknowledgment: false,
  },
  [NotificationType.MedicationMissed]: {
    id: 'medication_missed',
    category: 'clinical',
    channels: ['in_app', 'push', 'email'],
    priority: 'urgent',
    description: 'Medication administration was missed',
    requiresAcknowledgment: true,
  },
  [NotificationType.CarePlanUpdated]: {
    id: 'care_plan_updated',
    category: 'clinical',
    channels: ['in_app'],
    priority: 'normal',
    description: 'Resident care plan has been updated',
    requiresAcknowledgment: false,
  },
  [NotificationType.IncidentReported]: {
    id: 'incident_reported',
    category: 'clinical',
    channels: ['in_app', 'push', 'email'],
    priority: 'urgent',
    description: 'Incident has been reported',
    requiresAcknowledgment: true,
  },
  [NotificationType.AssessmentDue]: {
    id: 'assessment_due',
    category: 'clinical',
    channels: ['in_app', 'push'],
    priority: 'high',
    description: 'Assessment is due',
    requiresAcknowledgment: false,
  },
};

// ══════════════════════════════════════════════════════════════════════════════
// VALIDATION HELPERS
// ══════════════════════════════════════════════════════════════════════════════

export function isValidScope(scope: string): scope is Scope {
  return Object.values(Scope).includes(scope as Scope);
}

export function isValidComplianceFramework(framework: string): framework is ComplianceFramework {
  return Object.values(ComplianceFramework).includes(framework as ComplianceFramework);
}

export function isValidEdgeType(edgeType: string): edgeType is EdgeType {
  return Object.values(EdgeType).includes(edgeType as EdgeType);
}

export function isValidFormFieldType(fieldType: string): fieldType is FormFieldType {
  return Object.values(FormFieldType).includes(fieldType as FormFieldType);
}

export function isValidEventType(eventType: string): eventType is EventType {
  return Object.values(EventType).includes(eventType as EventType);
}

export function isValidNotificationType(notifType: string): notifType is NotificationType {
  return Object.values(NotificationType).includes(notifType as NotificationType);
}
